<template>
  <div id="login">
    <div class="login-page">
      <transition name="fade">
        <div v-if="!registerActive" class="wallpaper-login"></div>
      </transition>
      <div class="wallpaper-register"></div>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-8 col-xs-4 mx-auto">
            <div
              id="login-card"
              v-if="!registerActive"
              class="card login"
              v-bind:class="{ error: emptyFields }"
            >
              <h1>เข้าสู่ระบบ</h1>
              <h6 style="color: red">{{ message }}</h6>

              <form class="form-group" @submit.prevent="login">
                <input
                  v-model="inputLogin.std_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="รหัสนักศึกษา/รหัสอาจารย์"
                  required
                />
                <input
                  v-model="inputLogin.password"
                  type="password"
                  class="form-control input-style"
                  placeholder="รหัสผ่าน"
                  required
                />
                <button
                  :disabled="!isComplete"
                  id="button"
                  type="submit"
                  class="btn btn-purple deep-purple btn-block"
                >
                  ยืนยัน
                </button>

                <div
                  class="modal fade"
                  id="exampleModalCenter"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                >
                  <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div class="modal-content">
                      <!-- <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">
                          ข้อมูลส่วนตัว
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div> -->
                      <div class="modal-body">
                        <h5>รหัสเข้าใช้งานระบบ : 4 ตัวท้ายเบอร์โทรศัพท์</h5>
                        <p></p>
                        <hr />
                      </div>
                      <div class="modal-footer">
                        <!-- <button
                          type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                          v-if="!loginModal"
                        >
                          Close
                        </button> -->
                        <!-- v-if="loginModal" -->
                        <router-link
                          to="/"
                          class="btn btn-primary"
                          data-dismiss="modal"
                        >
                          รับทราบ</router-link
                        >

                        <!-- <a  href="/" type="button" class="btn btn-primary" v-if="loginModal"  data-dismiss="modal" >
                          รับทราบ
                        </a> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <input id="button" type="submit" class="btn btn-primary deep-purple btn-block" />  -->
                <p>
                  ยังไม่มีบัญชี
                  <a
                    href="#"
                    @click="
                      (registerActive = !registerActive), (emptyFields = false)
                    "
                    style="color: orangered; font-weight: bold"
                    >ลงทะเบียน ที่นี่</a
                  >
                </p>
                <!-- <p><a href="#">Forgot your password?</a></p> -->
              </form>
            </div>

            <div
              id="regis-card"
              v-else
              class="card register"
              v-bind:class="{ error: emptyFields }"
            >
              <h1>ลงทะเบียน</h1>
              <h6 style="color: red">{{message_regis}}</h6>

              <form class="form-group" @submit.prevent="register">
                <input
                  v-model="inputReg.std_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="รหัสนักศึกษา/อาจารย์"
                  required
                />
                <input
                  v-model="inputReg.email"
                  type="email"
                  class="form-control input-style"
                  placeholder="อีเมล มหาวิทยาลัย"
                  required
                />
                <input
                  v-model="inputReg.phone"
                  type="phone"
                  class="form-control input-style"
                  placeholder="เบอร์โทรศัพท์"
                  required
                />

                <b-form-checkbox
                  id="checkbox-1"
                  v-model="inputReg.chkpolicy"
                  type="checkbox"
                  class="text-left"
                  required
                >
                  ข้าพเจ้าได้อ่านทำความเข้าใจและยอมรับ
                  <a
                    style="color: rgb(255, 95, 45); font-weight: bold"
                    v-b-modal.modal-1
                    >เงื่อนไข ข้อกำหนด ข้อตกลงการให้บริการ </a
                  >เป็นที่เรียบร้อยแล้ว
                </b-form-checkbox>
                <b-modal
                  id="modal-1"
                  size="lg"
                  class="border-bottom-0"
                  hide-header
                >
                  <h5 class="my-4" style="font-weight: bold">
                    นโยบายความเป็นส่วนตัว
                  </h5>
                  <p class="indent">
                    นโยบายความเป็นส่วนตัวของสำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                    มหาวิทยาลัยราชภัฏอุบลราชธานี ซึ่งต่อไปนี้จะเรียกว่า
                    "ผู้ให้บริการ" สำหรับการใช้งานเว็บไซต์ UBRU Smart
                    library(USL) ด้านล่าง ซึ่งต่อไปนี้จะเรียกว่า “เว็บไซต์”<br />
                  </p>
                  <p class="indent">
                    โปรดอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัวนี้อย่างละเอียด
                    การที่ท่านได้เข้าใช้งานเว็บไซต์นี้แล้ว
                    ถือว่าท่านตกลงยอมรับข้อกำหนดที่ระบุในนโยบายความเป็นส่วนตัวนี้แล้วทุกประการ
                    หากท่านไม่สามารถยอมรับข้อกำหนดนโยบายความเป็นส่วนตัวนี้ได้
                    ขอให้ท่านปฏิเสธการใช้งานเว็บไซต์
                  </p>
                  <h5>1. วัตถุประสงค์ของนโยบายความเป็นส่วนตัว</h5>
                  <p class="indent">
                    ในการใช้งานเว็บไซต์นี้ผู้ให้บริการมีความประสงค์ที่จะแจ้งให้ท่านทราบอย่างชัดเจนว่าผู้ให้บริการรวบรวมข้อมูลส่วนใดของท่านบ้าง
                    มีวิธีการใช้และแบ่งปันข้อมูลของท่านอย่างไร
                    นโยบายความเป็นส่วนตัวนี้จะอธิบายถึง<br />
                  </p>
                  <p class="indent">
                    - ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม<br />
                  </p>
                  <p class="indent">- การใช้ข้อมูลที่รวบรวม<br /></p>
                  <p class="indent">
                    ผู้ให้บริการจะใช้ข้อมูลที่รวบรวมจากเว็บไซต์ทั้งหมดของผู้ให้บริการ
                    เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                    และพัฒนาบริการใหม่ๆ
                    ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                    ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                    แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                    แสดงข่าวประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                    ผู้ให้บริการอาจใช้ข้อมูลที่รวบรวมได้จากคุกกี้ อีเมล
                    เบอร์โทรศัพท์และเทคโนโลยีอื่นๆ เช่น การใช้ Tag เป็นต้น
                    ในการปรับปรุงประสบการณ์การใช้งานของท่าน
                    และคุณภาพโดยรวมของเว็บไซต์
                  </p>
                  <h6>ข้อมูลที่แบ่งปัน</h6>
                  <p class="indent">
                    ผู้ให้บริการจะไม่นำข้อมูลของท่านไปแบ่งปันหรือเปิดเผยให้กับบริษัท
                    และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก ยกเว้นกรณี
                    ดังต่อไปนี้
                  </p>
                  <p class="indent">
                    - เมื่อได้รับความยินยอมจากท่าน
                    ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับบริษัท
                    และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                    เมื่อได้รับความยิมยอมจากท่านให้แบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนของท่านก่อน
                  </p>
                  <p class="indent">
                    - เพื่อ
                    “การใช้ข้อมูลที่รวบรวม”ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับคู่สัญญาที่มีหน้าที่บริหารจัดการเว็บไซต์ตามสัญญากับผู้ให้บริการโดยตรง
                    เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                    พัฒนาบริการใหม่ๆ และปกป้องผู้ให้บริการและท่าน
                    ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                    ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                    แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                    แสดงโฆษณาประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                    โดยดำเนินการตามคำแนะนำและตามนโยบายส่วนบุคคลของผู้ให้บริการ
                    รวมถึงมาตรการการรักษาข้อมูลที่เป็นความลับและการรักษาความปลอดภัยที่เหมาะสม
                  </p>
                  <p class="indent">
                    - สำหรับเหตุผลทางกฎหมาย
                    ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลของท่านกับบริษัท
                    และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                    หากผู้ให้บริการเชื่อโดยสุจริตว่าการเข้าถึง การใช้
                    การเก็บรักษา หรือการเปิดเผยข้อมูลนั้น มีเหตุจำเป็นอันสมควร
                    (1) เพื่อการปฏิบัติตามกฎหมาย ระเบียบข้อบังคับ หลักเกณฑ์
                    คำสั่งที่เกี่ยวข้องและการร้องขอข้อมูลจากทางราชการ (2)
                    เพื่อบังคับใช้ข้อกำหนดในการให้บริการที่เกี่ยวข้อง
                    รวมถึงการตรวจสอบการละเมิดที่อาจเกิดขึ้น (3) เพื่อตรวจจับ
                    ป้องกัน หรือตรวจสอบการทุจริต
                    ปัญหาด้านความปลอดภัยหรือด้านเทคนิค (4)
                    เพื่อป้องกันอันตรายต่อสิทธิ ทรัพย์สิน
                    หรือความปลอดภัยของผู้ให้บริการและ/หรือของท่าน
                    หรือบุคคลอื่นตามที่กฎหมายกำหนด
                    ผู้ให้บริการอาจแบ่งปันข้อมูลที่ไม่สามารถระบุตัวผู้ใช้งานเว็บไซต์
                    เช่น ผลการค้นหา เครือข่ายโทรศัพท์เคลื่อนที่ที่ใช้งาน
                    IPการเข้าใช้งาน เป็นต้น ต่อสาธารณะ เช่น
                    เว็บไซต์ที่เชื่อมโยงกัน เช่น
                    ผู้ให้บริการอาจแบ่งปันข้อมูลที่แสดงแนวโน้มการใช้งานเว็บไซต์
                    สู่สาธารณะ เป็นต้น
                  </p>
                  <h5>2. ความปลอดภัยของข้อมูล</h5>
                  <p class="indent">
                    ผู้ให้บริการพยายามอย่างยิ่งที่จะปกป้องข้อมูลของท่านจากการเข้าถึง
                    การแก้ไขเปลี่ยนแปลง การเปิดเผย
                    หรือการทำลายโดยไม่ได้รับอนุญาต อย่างน้อยดังนี้
                  </p>
                  <p class="indent">
                    - ผู้ให้บริการจัดทำระบบ One-Time Password (OTP)
                    เพื่อใช้ยืนยันผู้ใช้งานเว็บไซต์
                    เมื่อเข้าใช้งานโดยเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                    และ Wi-Fi
                  </p>
                  <p class="indent">
                    - ผู้ให้บริการตรวจสอบการเก็บรวบรวมข้อมูล
                    พื้นที่ในการจัดเก็บข้อมูลและหลักปฏิบัติในการประมวลผล
                    รวมถึงมาตรการความปลอดภัยทางกายภาพ
                    เพื่อป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
                  </p>
                  <p class="indent">
                    -
                    ผู้ให้บริการจำกัดการเข้าถึงข้อมูลส่วนบุคคลไว้เฉพาะกับพนักงาน
                    และลูกจ้าง ที่มีความจำเป็นต้องเข้าถึงข้อมูลนั้นๆ (Need to
                    Know Basis) เพื่อทำการประมวลผลข้อมูล
                    โดยที่บุคคลดังกล่าวนั้น
                    จะต้องปฏิบัติตามข้อกำหนดเกี่ยวกับการรักษาข้อมูลที่เป็นความลับตามสัญญาอย่างเคร่งครัด
                    หากฝ่าฝืนจะมีบทลงโทษขั้นรุนแรง
                  </p>

                  <h5>3. ข้อจำกัดการใช้นโยบายความเป็นส่วนตัว</h5>
                  <p class="indent">
                    นโยบายความเป็นส่วนตัวฉบับนี้
                    มีผลใช้บังคับกับเว็บไซต์นี้เท่านั้น
                    ไม่รวมถึงเว็บไซต์และ/หรือบริการที่มีนโยบายความเป็นส่วนตัว
                    แยกต่างหาก
                    และ/หรือที่ไม่ได้กำหนดโดยชัดแจ้งให้ใช้ร่วมกันกับนโยบายความเป็นส่วนตัวนี้
                    ตลอดจนไม่มีผลใช้บังคับกับเว็บไซต์และบริการ
                    หรือเว็บไซต์อื่นๆ ที่เชื่อมต่อ (link) กับเว็บไซต์นี้
                    รวมถึงไม่ครอบคลุมหลักปฏิบัติด้านข้อมูลส่วนบุคคลของบริษัทอื่นๆ
                    หรือองค์กรอื่นๆ ที่โฆษณาเว็บไซต์ของผู้ให้บริการ
                    ซึ่งอาจใช้คุกกี้ พิกเซลแท็ก และเทคโนโลยีอื่นๆ
                    ในการนำเสนอและแสดงโฆษณาที่เกี่ยวข้อง
                  </p>
                  <h5>
                    4.
                    การปฏิบัติตามกฎหมายและการให้ความร่วมมือกับหน่วยงานกำกับดูแล
                  </h5>
                  <p class="indent">
                    ผู้ให้บริการดำเนินการตรวจสอบและทบทวนการปฏิบัติตามนโยบายความเป็นส่วนตัว
                    และการปฏิบัติตามกฎหมายที่เกี่ยวข้อง
                    ภายในองค์กรอย่างสม่ำเสมอ (Self-Regulator)
                    หากผู้ให้บริการได้รับหนังสือร้องเรียนเกี่ยวกับการใช้ข้อมูลส่วนบุคคล
                    ผู้ให้บริการจะดำเนินการติดตามผล
                    ตลอดจนให้ความร่วมมือกับหน่วยงานของรัฐที่มีอำนาจกำกับดูแลการให้บริการเว็บไซต์
                    และหน่วยงานคุ้มครองผู้บริโภคต่างๆ
                  </p>
                  <h5>5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h5>
                  <p class="indent">
                    ผู้ให้บริการขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลา
                    โดยไม่ต้องได้รับความยินยอมจากท่านล่วงหน้า
                    เว้นแต่เป็นการแก้ไขเปลี่ยนแปลงที่เป็นการริดรอนสิทธิของท่านตามนโยบายความเป็นส่วนตัวนี้
                    ผู้ให้บริการจะกระทำมิได้หากไม่ได้รับความยินยอมจากท่านก่อน
                  </p>
                  <h5>6. การเข้าถึงและอัปเดตข้อมูลส่วนบุคคล</h5>
                  <p class="indent">
                    ผู้ให้บริการมุ่งหวังเป็นอย่างยิ่งว่า ในการใช้เว็บไซต์
                    ท่านสามารถเข้าถึงข้อมูลส่วนบุคคลของท่านได้
                    หากข้อมูลดังกล่าวมีความบกพร่องหรือไม่ถูกต้อง
                    ผู้ให้บริการจะพยายามจัดหาวิธีการ
                    และ/หรือช่องทางให้ท่านสามารถอัปเดตและ/หรือลบข้อมูลส่วนบุคคลของท่าน
                    ได้อย่างเหมาะสม เว้นแต่
                    ในกรณีมีความจำเป็นที่ผู้ให้บริการจะต้องจัดเก็บข้อมูลส่วนบุคคลของท่านไว้
                    เพื่อประโยชน์ทางการให้บริการ
                    และ/หรือเพื่อการปฏิบัติตามกฎหมายที่ใช้บังคับ
                    เมื่อท่านดำเนินการอัปเดตข้อมูลส่วนบุคคลของท่าน
                    ผู้ให้บริการอาจร้องขอให้ท่านยืนยันตัวตนก่อนที่ผู้ให้บริการจะดำเนินการตามคำขอของท่านได้
                    ทั้งนี้
                    ผู้ให้บริการขอสงวนสิทธิ์ปฏิเสธการทำคำขออัปเดตและการเข้าถึงข้อมูลส่วนบุคคลของท่าน
                    ในกรณีดังต่อไปนี้ (1)
                    การทำคำขอที่ซับซ้อนและมีจำนวนมากเกินกว่าปกติ (2)
                    การดำเนินการตามคำขออาจทำให้ผู้ให้บริการต้องจัดหา
                    และ/หรือพัฒนาเทคโนโลยีจากที่ผู้ให้บริการมีอยู่เกินสมควร
                    (3)
                    การดำเนินการตามคำขออาจกระทบข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์อื่นๆ
                    หรือ (4) การดำเนินการตามคำขอไม่สามารถปฏิบัติได้จริง เช่น
                    คำขอเกี่ยวกับการเรียกดูข้อมูลส่วนบุคคลที่อยู่ในระบบสำรองข้อมูล
                    ผู้ให้บริการมุ่งหวังที่จะดำเนินการให้บริการเว็บไซต์ของผู้ให้บริการเป็นไปอย่างปลอดภัย
                    และสามารถป้องกันการทำลายข้อมูลจากอุบัติเหตุหรือการมุ่งร้ายอื่นๆ
                    ด้วยเหตุนี้
                    ภายหลังจากที่ท่านลบข้อมูลออกจากเว็บไซต์ของผู้ให้บริการแล้ว
                    ผู้ให้บริการอาจยังไม่ดำเนินการลบสำเนาข้อมูลส่วนบุคคลที่มีอยู่ออกจากเซิร์ฟเวอร์ที่ใช้งานอยู่
                    หรือนำข้อมูลออกจากระบบสำรองของผู้ให้บริการในทันที
                  </p>
                  <h6>ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม</h6>
                  <p class="indent">
                    “UBRU Smart Library เว็บไซต์
                    สำหรับใช้ในการจอง(เพื่อยืม)หนังสือ จองห้องกลุ่มย่อย
                    ตรวจเช็คการยืมคืนหนังสือ ค่าปรับหนังสือ กำหนดส่งหนังสือ
                    ค้นหาหนังสือ (OPAC) ประกาศข่าวสาร และยืมหนังสือต่อ (Renew)
                    เพื่อให้ผู้ใช้บริการได้ทราบถึงข้อมูลในการใช้บริการของผู้ให้บริการ
                    เป็นต้น”
                  </p>
                  <p class="indent">
                    ผู้ให้บริการเก็บรวบรวมข้อมูล
                    เพื่อนำมาใช้ในการพัฒนาและปรับปรุงการให้บริการที่ดีขึ้นแก่ท่าน
                    โดยเริ่มตั้งแต่ข้อมูลพื้นฐาน อย่างเช่น
                    ช่วงเวลาการจองหนังสือ เป็นต้น ตลอดจนข้อมูลที่มีความซับซ้อน
                    เช่น ประเภทหนังสือที่มีการจองมากที่สุด เป็นต้น
                    ด้วยวิธีดังต่อไปนี้
                  </p>
                  <h6>ข้อมูลที่ท่านให้ผู้ให้บริการ</h6>
                  <p class="indent">
                    ให้ท่านแจ้งหรือกรอกข้อมูลส่วนบุคคลของท่าน เช่น
                    รหัสนักศึกษา รหัสอาจารย์ รหัสบุคคลากร รหัสผู้ใช้งานภายนอก
                    อีเมล อาชีพ ที่อยู่ เลขประจำตัวประชาชน
                    และหมายเลขโทรศัพท์เป็นต้น
                    สำหรับเว็บไซต์ที่ต้องให้มีการลงทะเบียนก่อนการใช้งาน
                    เพื่อจัดเก็บและบันทึกไว้ในบัญชีผู้ใช้งาน ภายในเว็บไซต์
                    นอกจากนี้
                    หากท่านประสงค์ที่จะใช้ประโยชน์อย่างเต็มที่จากการใช้งานเว็บไซต์
                    ผู้ให้บริการอาจต้องขอให้ท่านสร้างโปรไฟล์สาธารณะที่มีชื่อและรูปภาพของท่านอยู่ด้วย
                  </p>
                  <h6>
                    ข้อมูลที่ผู้ให้บริการได้รับจากการใช้งานเว็บไซต์ของท่านข้อมูลที่ท่านให้ผู้ให้บริการ
                  </h6>
                  <p class="indent">
                    ผู้ให้บริการรวบรวมข้อมูลจากการใช้งานเว็บไซต์ของท่าน เช่น
                    ค้นหาหนังสือ
                    หรือเมื่อท่านเรียกดูข่าวสารของผู้ให้บริการเป็นต้น
                    ซึ่งประกอบด้วยข้อมูลอย่างน้อยดังนี้<br />

                    (1) ข้อมูลเครื่องโทรศัพท์เคลื่อนที่/อุปกรณ์ดิจิตอล :
                    ผู้ให้บริการจะรวบรวมข้อมูลเฉพาะของอุปกรณ์ เช่น
                    รุ่นฮาร์ดแวร์ ระบบปฏิบัติการและรุ่นของระบบปฏิบัติการ
                    ข้อมูลเครือข่ายโทรศัพท์เคลื่อนที่ หมายเลขโทรศัพท์
                    ตลอดจนตัวระบุอุปกรณ์ที่ทำให้ผู้ให้บริการทราบว่าท่านเข้าใช้งานเว็บไซต์จากเครื่องใด
                    เพื่อนำมาปรับแต่งการให้บริการและวิเคราะห์ปัญหาที่เหมาะสมกับอุปกรณ์นั้นๆ<br />
                    (2) ข้อมูลที่ถูกบันทึก :
                    เมื่อท่านเรียกดูข้อมูลและ/หรือเนื้อหาจากเว็บไซต์นี้
                    ผู้ให้บริการจะบันทึกการเรียกดูข้อมูลและ/หรือเนื้อหาดังกล่าวไว้ในแหล่งรวบรวมในเซิร์ฟเวอร์ของผู้ให้บริการเอง<br />
                    (3) ข้อมูลสถานะของเครื่องโทรศัพท์เคลื่อนที่ (Phone State)
                    :
                    ผู้ให้บริการอาจเข้าถึงและประมวลผลข้อมูลเกี่ยวกับสถานะการทำงานของเครื่องโทรศัพท์เคลื่อนที่ของท่านว่าเปิดเครื่อง
                    หรือปิดเครื่องอยู่
                    และ/หรือข้อมูลเกี่ยวกับการเชื่อมต่อเครือข่าย<br />
                    เช่น เลือกเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                    หรือระบบ Wi-Fi เป็นต้น วัตถุประสงค์ดังนี้
                  </p>
                  <p class="indent">
                    -
                    เพื่อให้สามารถตรวจสอบได้ว่าท่านสามารถใช้งานเว็บไซต์ได้โดยทันที
                    โดยไม่จำเป็นต้องกรอกข้อมูล OTP ก่อนใช้งานหรือไม่
                  </p>
                  <p class="indent">
                    - เพื่อการจัดทำรูปแบบหน้าจอแสดงผลของเว็บไซต์
                  </p>
                  <p class="indent">
                    -
                    เพื่อปรับแต่งการให้บริการเว็บไซต์ที่เหมาะสมกับสถานะการใช้งานเครื่องแต่ละรูปแบบ
                    เช่น การสลับรูปแบบการใช้งานเป็นต้น
                  </p>
                  <p>
                    (4) ข้อมูลบัญชีผู้ใช้งานเว็บไซต์ (Account) :
                    เมื่อท่านใช้งานเว็บไซต์ของผู้ให้บริการ
                    ผู้ให้บริการอาจเข้าถึง
                    รวบรวมและประมวลผลข้อมูลเกี่ยวกับบัญชีผู้ใช้งานเว็บไซต์
                    (Account) ของท่าน สำหรับการตรวจสอบ Token และ/หรือ UDID
                    ของเครื่องโทรศัพท์เคลื่อนที่ วัตถุประสงค์ดังนี้
                  </p>
                  <p class="indent">
                    -
                    เพื่อการจัดทำข่าวประชาสัมพันธ์เกี่ยวกับผู้ให้บริการและเว็บไซต์
                  </p>
                  <p class="indent">- แสดงข้อมูลหนังสือแนะนำ</p>
                  <p>
                    (5) คุกกี้และเทคโนโลยีที่คล้ายกัน (Cookies and Similar
                    Technologies) : ผู้ให้บริการ อาจใช้เทคโนโลยีต่างๆ
                    ในการรวบรวมและจัดเก็บข้อมูลเมื่อท่านเยี่ยมชมเว็บไซต์และ/หรือบริการของผู้ให้บริการ
                    โดยการใช้คุกกี้และเทคโนโลยีที่คล้ายกัน
                    เพื่อระบุเบราว์เซอร์ หรืออุปกรณ์
                    และ/หรือเพื่อรวบรวมและจัดเก็บข้อมูลเมื่อท่านมีการโต้ตอบกับบริการที่ผู้ให้บริการ
                    เช่น บริการประชาสัมพันธ์ ข่าวสาร สื่อ เป็นต้น <br />
                    (6) ข้อมูลหมายเลขเฉพาะของเว็บไซต์ (Unique Application
                    Number) : เว็บไซต์นี้มีหมายเลขเฉพาะของเว็บไซต์
                    สำหรับการส่งข้อมูลมายังผู้ให้บริการ
                    เมื่อผู้ใช้บริการเข้าใช้งานเว็บไซต์นั้นๆ
                    หรือเมื่อเว็บไซต์นั้นติดต่อกับระบบเซิร์ฟเวอร์การให้บริการของผู้ให้บริการเป็นคราวๆไป
                    วัตถุประสงค์ดังนี้
                  </p>
                  <p class="indent">
                    - เพื่อการอัปเดตข้อมูลเว็บไซต์โดยอัตโนมัติ
                  </p>
                  <p>
                    (7) ข้อมูลพื้นที่การจัดเก็บข้อมูลในตัวเครื่อง (Storage) :
                    ผู้ให้บริการอาจรวบรวมและจัดเก็บข้อมูล
                    พื้นที่การจัดเก็บข้อมูลในตัวเครื่อง
                    รวมถึงข้อมูลส่วนบุคคลที่อยู่ในอุปกรณ์ของท่าน
                    โดยใช้วิธีการต่างๆ เช่น
                    พื้นที่จัดเก็บข้อมูลเว็บเบราว์เซอร์
                    และแคชของข้อมูลเว็บไซต์ วัตถุประสงค์ดังนี้
                  </p>
                  <p class="indent">
                    - เพื่ออนุญาตให้เว็บไซต์สามารถอ่านข้อมูลได้ -
                    เพื่อแสดงข้อมูลของผู้ใช้ตามการเข้าใช้งานบนเว็บไซต์
                  </p>
                  <h3>
                    ข้อตกลงและเงื่อนไขการใช้บริการ เว็บไซต์ UBRU Smart library
                  </h3>
                  <p class="indent">
                    เงื่อนไขการใช้บริการเว็บไซต์ UBRU Smart library
                    (ซึ่งต่อไปนี้จะเรียกว่า “เงื่อนไขการใช้บริการ”)
                    เป็นข้อตกลงสําหรับการใช้บริการเว็บไซต์ UBRU Smart library
                    ซึ่ง
                    เป็นการให้บริการเว็บไซต์ที่ช่วยให้ผู้ใช้บริการเข้าถึงบริการของสำนักวิทยบริการและเทคโนโลยีสารสนเทศได้อย่างสะดวก
                    และรวดเร็ว (UBRU Smart library) (ซึ่งต่อไปนี้จะเรียกว่า
                    “บริการ”) ซึ่งให้บริการโดย
                    สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                    (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ให้บริการ”) ฝ่ายหนึ่ง
                    กับผู้สมัครใช้บริการ เว็บไซต์ UBRU Smart library
                    (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ใช้บริการ”) อีกฝ่ายหนึ่ง
                    โดยเงื่อนไขการใช้บริการนี้อาจมีลักษณะกระทบสิทธิของผู้ใช้
                    บริการซึ่งผู้ใช้บริการควรอ่านและทําความเข้าใจอย่างละเอียดและหากมีข้อสงสัยเกี่ยวกับบริการของผู้ให้บริการ
                    ผู้ใช้บริการสามารถติดต่อสอบถาม ได้โดยทันทีที่
                    thongsian.c@ubru.ac.th
                  </p>

                  <h5>1. ข้อกําหนดทั่วไป</h5>
                  <p class="indent">
                    1.1
                    ผู้ใช้บริการตกลงที่จะปฏิบัติและผูกพันตามเงื่อนไขการใช้บริการ
                    ซึ่งการใช้บริการของผู้ใช้บริการถือเป็นการยอมรับเงื่อนไขการใช้บริการ
                    นี้
                    โดยผู้ให้บริการอาจแก้ไขหรือเพิ่มเติมเงื่อนไขการใช้บริการได้ไม่ว่าในเวลาใด
                    โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    และการที่ผู้ใช้บริการ
                    ใช้บริการต่อไปภายหลังจากที่มีการแก้ไขหรือเพิ่มเติมดังกล่าว
                    ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                  </p>
                  <p class="indent">
                    1.2
                    ผู้ใช้บริการยอมรับว่าผู้ให้บริการมีสิทธิดําเนินการแก้ไข
                    เพิ่มเติม หรือปรับปรุงบริการ
                    ซึ่งผู้ใช้บริการอาจจําเป็นต้องอัปเดตเว็บไซต์ หรือ
                    ติดตั้งเว็บไซต์ใหม่ โดยให้ถือว่าบริการที่ได้แก้ไข
                    เพิ่มเติม
                    หรือปรับปรุงอยู่ภายใต้เงื่อนไขการใช้บริการฉบับนี้ทั้งสิ้น
                    และการที่ผู้ใช้
                    บริการใช้บริการต่อไปภายหลังจากที่มีการอัปเดตเว็บไซต์
                    หรือติดตั้งเว็บไซต์ใหม่
                    ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                  </p>
                  <p class="indent">
                    1.3 ผู้ให้บริการสงวนสิทธิ์ในการปรับปรุง
                    หรือยกเลิกการบริการ หรือส่วนใดส่วนหนึ่งของบริการ
                    ไม่ว่าจะเป็นการชั่วคราว
                    หรือตลอดไปได้ตลอดเวลาโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                  </p>

                  <h5>2. การใช้บริการ</h5>
                  <p class="indent">
                    2.1 ในการสมัครใช้บริการ
                    ผู้ใช้บริการสามารถสมัครผ่านเว็บไซต์ UBRU Smart Library
                    (USL) โดยผู้ใช้บริการจะต้องระบุรหัสนักศึกษา รหัสอาจารย์
                    รหัสบุคคลกร รหัสผู้ใช้บุคคลภายนอก อาชีพ
                    ที่อยู่ไปรษณีย์อิเล็กทรอนิกส์ (E-Mail)
                    รหัสบัตรประจำตัวประชาชน
                    ระบบจะทำการกำหนดรหัสผ่านให้อัตโนมัติเพื่อ
                    ใช้ในการทํารายการต่างๆอันเกี่ยวเนื่องกับการใช้บริการ
                    โดยผู้ใช้บริการไม่สามารถแก้ไขเปลี่ยนแปลงรหัสผ่านนี้เองได้
                    ตามข้อ กําหนดและเงื่อนไขของผู้ให้บริการ
                  </p>

                  <p class="indent">
                    2.2
                    ผู้ใช้บริการจะต้องเก็บรักษารหัสผ่านนี้ไว้เป็นความลับเฉพาะตัวของผู้ใช้บริการเท่านั้น
                    ผู้ใช้บริการยอมรับว่า หากมีการกระทําการใดๆโดย
                    ใช้รหัสผ่านของผู้ใช้บริการ
                    ให้ถือว่าเป็นการกระทําโดยผู้ใช้บริการเองทุกประการ
                    และผู้ให้บริการไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจาก
                    การใช้รหัสผ่านดังกล่าว
                  </p>

                  <p class="indent">
                    2.3 ในกรณีที่ผู้ใช้บริการใช้รหัสผ่านทํารายการใดๆ
                    อันเกี่ยวเนื่องกับการใช้บริการเสร็จสิ้นสมบูรณ์แล้ว
                    ผู้ใช้บริการยอมรับว่าไม่สามารถ ยกเลิก เพิกถอน เปลี่ยนแปลง
                    หรือแก้ไขรายการดังกล่าวได้
                    และผู้ใช้บริการต้องผูกพันตามรายการดังกล่าวทุกประการ
                  </p>

                  <p class="indent">
                    2.4 ผู้ใช้บริการรับทราบว่า
                    ในการใช้บริการหากมีการป้อนรหัสผ่านผิดติดต่อกันมากกว่าจํานวนครั้งที่ผู้ให้บริการกําหนด
                    ผู้ให้บริการจะระงับการใช้ บริการโดยอัตโนมัติทันที
                    ผู้ใช้บริการจะสามารถใช้บริการนี้ต่อไปได้ก็ต่อเมื่อแจ้งความจํานงให้ผู้ให้บริการดําเนินการตามวิธีอื่นใดที่ผู้ให้บริการกําหนด
                    เพื่อขอออกรหัสผ่านใหม่
                  </p>

                  <p class="indent">
                    2.5 ในกรณีที่ผู้ใช้บริการลืมรหัสผ่าน
                    หรือต้องการเปลี่ยนแปลงรหัสผ่านไม่ว่าด้วยเหตุใดๆ
                    ผู้ใช้บริการต้องดําเนินการแจ้งให้ผู้ให้บริการทราบทันที
                    ตามวิธีการอื่นใดที่ผู้ให้บริการกําหนด อย่างไรก็ตาม
                    การดําเนินการต่างๆข้างต้นจะไม่มีผลกระทบต่อการดำเนินการกิจกรรมใดๆที่ได้ดําเนินการไปแล้วก่อนการแจ้งให้ผู้ให้บริการทราบ
                  </p>
                  <p class="indent">
                    2.6 ในการใช้บริการ
                    หากผู้ใช้บริการนําบริการของผู้ให้บริการไปประยุกต์ใช้งานใดๆ
                    ผู้ใช้บริการรับทราบว่าผู้ให้บริการจะไม่รับผิดชอบต่อความเสีย
                    หายใดๆที่เกิดขึ้นจากการดําเนินการดังกล่าวของผู้ใช้บริการ
                  </p>
                  <p class="indent">
                    2.7
                    ผู้ให้บริการจะให้บริการอย่างดีที่สุดเพื่อให้ผู้ใช้บริการได้รับบริการที่พึงพอใจ
                    ดังนั้น หากการให้บริการใดๆของผู้ให้บริการเกิดความผิดพลาด
                    ล่าช้า ไม่ว่าเกิดขึ้นจากระบบคอมพิวเตอร์ ระบบอินเตอร์เน็ต
                    อุปกรณ์อิเล็กทรอนิกส์ต่างๆ
                    หรือระบบอื่นใดที่เกี่ยวข้องกับการให้บริการนี้ รวมทั้ง
                    ระบบเครือข่ายโทรศัพท์เคลื่อนที่ และไม่ว่าจะเกิดจากเหตุใดๆ
                    ผู้ใช้บริการตกลงไม่ยกเอาเหตุขัดข้องดังกล่าวมาเป็นข้อเรียกร้องค่าเสียหาย
                    ใดๆจากผู้ให้บริการ
                  </p>
                  <p class="indent">
                    2.9
                    ผู้ให้บริการจะไม่รับผิดชอบในทุกกรณีต่อความสูญหายหรือเสียหาย
                    ไม่ว่าจะโดยทางตรง
                    หรือโดยทางอ้อมอันเกิดขึ้นกับข้อมูลในโทรศัพท์ เคลื่อนที่,
                    โปรแกรมคอมพิวเตอร์, Tablet, อุปกรณ์
                  </p>
                  <h5>3. ข้อตกลงอื่นๆ</h5>
                  <p class="indent">
                    3.1
                    ในกรณีที่ข้อใดของเงื่อนไขการใช้บริการฉบับนี้ไม่มีผลใช้บังคับ
                    หรือไม่สามารถใช้บังคับได้ ให้ข้ออื่นที่เหลือยังคงมีผล
                    และสามารถใช้ บังคับได้ตามที่กําหนดไว้
                  </p>
                  <p class="indent">
                    3.2
                    หัวข้อในสัญญา/ใบคําขอให้บริการฉบับนี้มีไว้เพื่ออ้างถึงเท่านั้น
                    และไม่มีผลกระทบถึงความหมายหรือส่งผลต่อการตีความแต่อย่างใด
                  </p>
                  <p class="indent">
                    3.3
                    เงื่อนไขการใช้บริการฉบับนี้ให้อยู่ภายใต้บังคับแห่งกฎหมายไทย
                  </p>
                  <h5>4. การเปลี่ยนแปลงข้อกำหนดและเงื่อนไขนี้</h5>
                  <p class="indent">
                    ผู้ให้บริการขอสงวนสิทธิ์ในการปรับปรุงข้อตกลงและเงื่อนไขการให้บริการเป็นครั้งคราวโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                  </p>

                  <div padding>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เงื่อนไขการให้บริการนี้เป็นข้อตกลงระหว่าง
                    ซึ่งต่อไปนี้เรียกว่า "ผู้ให้บริการ" ฝ่ายหนึ่ง กับ
                    ผู้รับบริการ ซึ่งต่อไปนี้เรียกว่า "ผู้ใช้บริการ"
                    อีกฝ่ายหนึ่ง ซึ่งให้บริการ UBRU Smart Library Website
                    (USL) ซึ่งต่อไปนี้เรียกว่า "บริการ" โดยผู้ใช้บริการสามารถ
                    จอง (เพื่อยืม) หนังสือ จองห้องกลุ่มย่อย
                    ตรวจสอบวันส่งคืนหนังสือ ยืมหนังสือต่อ (Renew) ดูข่าวสาร
                    ดูประวัติยืมคืนหนังสือ
                    และประชาสัมพันธ์ต่างของสำนักวิทยบริการฯ
                  </div>

                  <template #modal-footer="{ ok }">
                    <b-button
                      size="lg"
                      @click="ok()"
                      class="btn btn-purple deep-purple btn-block"
                      pill
                    >
                      ฉันเข้าใจแล้ว
                    </b-button>
                  </template>
                </b-modal>

                <button
                  :disabled="!isCompleteRegister"
                  id="button"
                  type="submit"
                  class="btn btn-purple deep-purple btn-block"
                >
                  ยืนยัน
                </button>

                <p>
                  <a
                    href="#"
                    @click="
                      (registerActive = !registerActive),
                        (emptyFields = false)
                    "
                    style="color: orangered; font-weight: bold"
                    >เข้าสู่ระบบ</a
                  >
                </p>
              </form>
            
                  <!-- <div class="segmented-control center">
                    <input
                      type="radio"
                      name="radio2"
                      v-model="radio_btn"
                      @change="onChange"
                      value=""
                      id="tab-1"
                      checked
                    />
                    <label for="tab-1" class="segmented-control__1">
                      <p>นักศึกษา</p></label
                    >
                    <input
                      type="radio"
                      name="radio2"
                      v-model="radio_btn"
                      @change="onChange"
                      value="teacher"
                      id="tab-2"
                    />
                    <label for="tab-2" class="segmented-control__2">
                      <p>อาจารย์/บุคลากร</p>
                    </label>

                    <input
                      type="radio"
                      name="radio2"
                      v-model="radio_btn"
                      @change="onChange"
                      value="another"
                      id="tab-3"
                    />
                    <label for="tab-3" class="segmented-control__3">
                      <p>บุคคลภายนอก</p>
                    </label>

                    <div class="segmented-control__color"></div>
                  </div> -->
              

              <br />
              <!-- Std -->
              <!-- <span v-if="radio_btn === ''">
                <h6 style="color: red">{{ message_regis }}</h6>
                <form class="form-group" @submit.prevent="register">
                  <input
                    v-model="inputReg.std_code"
                    type="text"
                    class="form-control input-style"
                    placeholder="รหัสนักศึกษา"
                    required
                  />
                  <input
                    v-model="inputReg.email"
                    type="email"
                    class="form-control input-style"
                    placeholder="อีเมล มหาวิทยาลัย"
                    required
                  />
                  <input
                    v-model="inputReg.phone"
                    type="phone"
                    class="form-control input-style"
                    placeholder="เบอร์โทรศัพท์"
                    required
                  />

                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="inputReg.chkpolicy"
                    type="checkbox"
                    class="text-left"
                    required
                  >
                    ข้าพเจ้าได้อ่านทำความเข้าใจและยอมรับ
                    <a
                      style="color: rgb(255, 95, 45); font-weight: bold"
                      v-b-modal.modal-1
                      >เงื่อนไข ข้อกำหนด ข้อตกลงการให้บริการ </a
                    >เป็นที่เรียบร้อยแล้ว
                  </b-form-checkbox>
                  <b-modal
                    id="modal-1"
                    size="lg"
                    class="border-bottom-0"
                    hide-header
                  >
                    <h5 class="my-4" style="font-weight: bold">
                      นโยบายความเป็นส่วนตัว
                    </h5>
                    <p class="indent">
                      นโยบายความเป็นส่วนตัวของสำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                      มหาวิทยาลัยราชภัฏอุบลราชธานี ซึ่งต่อไปนี้จะเรียกว่า
                      "ผู้ให้บริการ" สำหรับการใช้งานเว็บไซต์ UBRU Smart
                      library(USL) ด้านล่าง ซึ่งต่อไปนี้จะเรียกว่า “เว็บไซต์”<br />
                    </p>
                    <p class="indent">
                      โปรดอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัวนี้อย่างละเอียด
                      การที่ท่านได้เข้าใช้งานเว็บไซต์นี้แล้ว
                      ถือว่าท่านตกลงยอมรับข้อกำหนดที่ระบุในนโยบายความเป็นส่วนตัวนี้แล้วทุกประการ
                      หากท่านไม่สามารถยอมรับข้อกำหนดนโยบายความเป็นส่วนตัวนี้ได้
                      ขอให้ท่านปฏิเสธการใช้งานเว็บไซต์
                    </p>
                    <h5>1. วัตถุประสงค์ของนโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      ในการใช้งานเว็บไซต์นี้ผู้ให้บริการมีความประสงค์ที่จะแจ้งให้ท่านทราบอย่างชัดเจนว่าผู้ให้บริการรวบรวมข้อมูลส่วนใดของท่านบ้าง
                      มีวิธีการใช้และแบ่งปันข้อมูลของท่านอย่างไร
                      นโยบายความเป็นส่วนตัวนี้จะอธิบายถึง<br />
                    </p>
                    <p class="indent">
                      - ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม<br />
                    </p>
                    <p class="indent">- การใช้ข้อมูลที่รวบรวม<br /></p>
                    <p class="indent">
                      ผู้ให้บริการจะใช้ข้อมูลที่รวบรวมจากเว็บไซต์ทั้งหมดของผู้ให้บริการ
                      เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                      และพัฒนาบริการใหม่ๆ
                      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                      ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                      แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                      แสดงข่าวประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                      ผู้ให้บริการอาจใช้ข้อมูลที่รวบรวมได้จากคุกกี้ อีเมล
                      เบอร์โทรศัพท์และเทคโนโลยีอื่นๆ เช่น การใช้ Tag เป็นต้น
                      ในการปรับปรุงประสบการณ์การใช้งานของท่าน
                      และคุณภาพโดยรวมของเว็บไซต์
                    </p>
                    <h6>ข้อมูลที่แบ่งปัน</h6>
                    <p class="indent">
                      ผู้ให้บริการจะไม่นำข้อมูลของท่านไปแบ่งปันหรือเปิดเผยให้กับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก ยกเว้นกรณี
                      ดังต่อไปนี้
                    </p>
                    <p class="indent">
                      - เมื่อได้รับความยินยอมจากท่าน
                      ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                      เมื่อได้รับความยิมยอมจากท่านให้แบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนของท่านก่อน
                    </p>
                    <p class="indent">
                      - เพื่อ
                      “การใช้ข้อมูลที่รวบรวม”ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับคู่สัญญาที่มีหน้าที่บริหารจัดการเว็บไซต์ตามสัญญากับผู้ให้บริการโดยตรง
                      เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                      พัฒนาบริการใหม่ๆ และปกป้องผู้ให้บริการและท่าน
                      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                      ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                      แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                      แสดงโฆษณาประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                      โดยดำเนินการตามคำแนะนำและตามนโยบายส่วนบุคคลของผู้ให้บริการ
                      รวมถึงมาตรการการรักษาข้อมูลที่เป็นความลับและการรักษาความปลอดภัยที่เหมาะสม
                    </p>
                    <p class="indent">
                      - สำหรับเหตุผลทางกฎหมาย
                      ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลของท่านกับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                      หากผู้ให้บริการเชื่อโดยสุจริตว่าการเข้าถึง การใช้
                      การเก็บรักษา หรือการเปิดเผยข้อมูลนั้น มีเหตุจำเป็นอันสมควร
                      (1) เพื่อการปฏิบัติตามกฎหมาย ระเบียบข้อบังคับ หลักเกณฑ์
                      คำสั่งที่เกี่ยวข้องและการร้องขอข้อมูลจากทางราชการ (2)
                      เพื่อบังคับใช้ข้อกำหนดในการให้บริการที่เกี่ยวข้อง
                      รวมถึงการตรวจสอบการละเมิดที่อาจเกิดขึ้น (3) เพื่อตรวจจับ
                      ป้องกัน หรือตรวจสอบการทุจริต
                      ปัญหาด้านความปลอดภัยหรือด้านเทคนิค (4)
                      เพื่อป้องกันอันตรายต่อสิทธิ ทรัพย์สิน
                      หรือความปลอดภัยของผู้ให้บริการและ/หรือของท่าน
                      หรือบุคคลอื่นตามที่กฎหมายกำหนด
                      ผู้ให้บริการอาจแบ่งปันข้อมูลที่ไม่สามารถระบุตัวผู้ใช้งานเว็บไซต์
                      เช่น ผลการค้นหา เครือข่ายโทรศัพท์เคลื่อนที่ที่ใช้งาน
                      IPการเข้าใช้งาน เป็นต้น ต่อสาธารณะ เช่น
                      เว็บไซต์ที่เชื่อมโยงกัน เช่น
                      ผู้ให้บริการอาจแบ่งปันข้อมูลที่แสดงแนวโน้มการใช้งานเว็บไซต์
                      สู่สาธารณะ เป็นต้น
                    </p>
                    <h5>2. ความปลอดภัยของข้อมูล</h5>
                    <p class="indent">
                      ผู้ให้บริการพยายามอย่างยิ่งที่จะปกป้องข้อมูลของท่านจากการเข้าถึง
                      การแก้ไขเปลี่ยนแปลง การเปิดเผย
                      หรือการทำลายโดยไม่ได้รับอนุญาต อย่างน้อยดังนี้
                    </p>
                    <p class="indent">
                      - ผู้ให้บริการจัดทำระบบ One-Time Password (OTP)
                      เพื่อใช้ยืนยันผู้ใช้งานเว็บไซต์
                      เมื่อเข้าใช้งานโดยเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                      และ Wi-Fi
                    </p>
                    <p class="indent">
                      - ผู้ให้บริการตรวจสอบการเก็บรวบรวมข้อมูล
                      พื้นที่ในการจัดเก็บข้อมูลและหลักปฏิบัติในการประมวลผล
                      รวมถึงมาตรการความปลอดภัยทางกายภาพ
                      เพื่อป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
                    </p>
                    <p class="indent">
                      -
                      ผู้ให้บริการจำกัดการเข้าถึงข้อมูลส่วนบุคคลไว้เฉพาะกับพนักงาน
                      และลูกจ้าง ที่มีความจำเป็นต้องเข้าถึงข้อมูลนั้นๆ (Need to
                      Know Basis) เพื่อทำการประมวลผลข้อมูล
                      โดยที่บุคคลดังกล่าวนั้น
                      จะต้องปฏิบัติตามข้อกำหนดเกี่ยวกับการรักษาข้อมูลที่เป็นความลับตามสัญญาอย่างเคร่งครัด
                      หากฝ่าฝืนจะมีบทลงโทษขั้นรุนแรง
                    </p>

                    <h5>3. ข้อจำกัดการใช้นโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      นโยบายความเป็นส่วนตัวฉบับนี้
                      มีผลใช้บังคับกับเว็บไซต์นี้เท่านั้น
                      ไม่รวมถึงเว็บไซต์และ/หรือบริการที่มีนโยบายความเป็นส่วนตัว
                      แยกต่างหาก
                      และ/หรือที่ไม่ได้กำหนดโดยชัดแจ้งให้ใช้ร่วมกันกับนโยบายความเป็นส่วนตัวนี้
                      ตลอดจนไม่มีผลใช้บังคับกับเว็บไซต์และบริการ
                      หรือเว็บไซต์อื่นๆ ที่เชื่อมต่อ (link) กับเว็บไซต์นี้
                      รวมถึงไม่ครอบคลุมหลักปฏิบัติด้านข้อมูลส่วนบุคคลของบริษัทอื่นๆ
                      หรือองค์กรอื่นๆ ที่โฆษณาเว็บไซต์ของผู้ให้บริการ
                      ซึ่งอาจใช้คุกกี้ พิกเซลแท็ก และเทคโนโลยีอื่นๆ
                      ในการนำเสนอและแสดงโฆษณาที่เกี่ยวข้อง
                    </p>
                    <h5>
                      4.
                      การปฏิบัติตามกฎหมายและการให้ความร่วมมือกับหน่วยงานกำกับดูแล
                    </h5>
                    <p class="indent">
                      ผู้ให้บริการดำเนินการตรวจสอบและทบทวนการปฏิบัติตามนโยบายความเป็นส่วนตัว
                      และการปฏิบัติตามกฎหมายที่เกี่ยวข้อง
                      ภายในองค์กรอย่างสม่ำเสมอ (Self-Regulator)
                      หากผู้ให้บริการได้รับหนังสือร้องเรียนเกี่ยวกับการใช้ข้อมูลส่วนบุคคล
                      ผู้ให้บริการจะดำเนินการติดตามผล
                      ตลอดจนให้ความร่วมมือกับหน่วยงานของรัฐที่มีอำนาจกำกับดูแลการให้บริการเว็บไซต์
                      และหน่วยงานคุ้มครองผู้บริโภคต่างๆ
                    </p>
                    <h5>5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      ผู้ให้บริการขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลา
                      โดยไม่ต้องได้รับความยินยอมจากท่านล่วงหน้า
                      เว้นแต่เป็นการแก้ไขเปลี่ยนแปลงที่เป็นการริดรอนสิทธิของท่านตามนโยบายความเป็นส่วนตัวนี้
                      ผู้ให้บริการจะกระทำมิได้หากไม่ได้รับความยินยอมจากท่านก่อน
                    </p>
                    <h5>6. การเข้าถึงและอัปเดตข้อมูลส่วนบุคคล</h5>
                    <p class="indent">
                      ผู้ให้บริการมุ่งหวังเป็นอย่างยิ่งว่า ในการใช้เว็บไซต์
                      ท่านสามารถเข้าถึงข้อมูลส่วนบุคคลของท่านได้
                      หากข้อมูลดังกล่าวมีความบกพร่องหรือไม่ถูกต้อง
                      ผู้ให้บริการจะพยายามจัดหาวิธีการ
                      และ/หรือช่องทางให้ท่านสามารถอัปเดตและ/หรือลบข้อมูลส่วนบุคคลของท่าน
                      ได้อย่างเหมาะสม เว้นแต่
                      ในกรณีมีความจำเป็นที่ผู้ให้บริการจะต้องจัดเก็บข้อมูลส่วนบุคคลของท่านไว้
                      เพื่อประโยชน์ทางการให้บริการ
                      และ/หรือเพื่อการปฏิบัติตามกฎหมายที่ใช้บังคับ
                      เมื่อท่านดำเนินการอัปเดตข้อมูลส่วนบุคคลของท่าน
                      ผู้ให้บริการอาจร้องขอให้ท่านยืนยันตัวตนก่อนที่ผู้ให้บริการจะดำเนินการตามคำขอของท่านได้
                      ทั้งนี้
                      ผู้ให้บริการขอสงวนสิทธิ์ปฏิเสธการทำคำขออัปเดตและการเข้าถึงข้อมูลส่วนบุคคลของท่าน
                      ในกรณีดังต่อไปนี้ (1)
                      การทำคำขอที่ซับซ้อนและมีจำนวนมากเกินกว่าปกติ (2)
                      การดำเนินการตามคำขออาจทำให้ผู้ให้บริการต้องจัดหา
                      และ/หรือพัฒนาเทคโนโลยีจากที่ผู้ให้บริการมีอยู่เกินสมควร
                      (3)
                      การดำเนินการตามคำขออาจกระทบข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์อื่นๆ
                      หรือ (4) การดำเนินการตามคำขอไม่สามารถปฏิบัติได้จริง เช่น
                      คำขอเกี่ยวกับการเรียกดูข้อมูลส่วนบุคคลที่อยู่ในระบบสำรองข้อมูล
                      ผู้ให้บริการมุ่งหวังที่จะดำเนินการให้บริการเว็บไซต์ของผู้ให้บริการเป็นไปอย่างปลอดภัย
                      และสามารถป้องกันการทำลายข้อมูลจากอุบัติเหตุหรือการมุ่งร้ายอื่นๆ
                      ด้วยเหตุนี้
                      ภายหลังจากที่ท่านลบข้อมูลออกจากเว็บไซต์ของผู้ให้บริการแล้ว
                      ผู้ให้บริการอาจยังไม่ดำเนินการลบสำเนาข้อมูลส่วนบุคคลที่มีอยู่ออกจากเซิร์ฟเวอร์ที่ใช้งานอยู่
                      หรือนำข้อมูลออกจากระบบสำรองของผู้ให้บริการในทันที
                    </p>
                    <h6>ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม</h6>
                    <p class="indent">
                      “UBRU Smart Library เว็บไซต์
                      สำหรับใช้ในการจอง(เพื่อยืม)หนังสือ จองห้องกลุ่มย่อย
                      ตรวจเช็คการยืมคืนหนังสือ ค่าปรับหนังสือ กำหนดส่งหนังสือ
                      ค้นหาหนังสือ (OPAC) ประกาศข่าวสาร และยืมหนังสือต่อ (Renew)
                      เพื่อให้ผู้ใช้บริการได้ทราบถึงข้อมูลในการใช้บริการของผู้ให้บริการ
                      เป็นต้น”
                    </p>
                    <p class="indent">
                      ผู้ให้บริการเก็บรวบรวมข้อมูล
                      เพื่อนำมาใช้ในการพัฒนาและปรับปรุงการให้บริการที่ดีขึ้นแก่ท่าน
                      โดยเริ่มตั้งแต่ข้อมูลพื้นฐาน อย่างเช่น
                      ช่วงเวลาการจองหนังสือ เป็นต้น ตลอดจนข้อมูลที่มีความซับซ้อน
                      เช่น ประเภทหนังสือที่มีการจองมากที่สุด เป็นต้น
                      ด้วยวิธีดังต่อไปนี้
                    </p>
                    <h6>ข้อมูลที่ท่านให้ผู้ให้บริการ</h6>
                    <p class="indent">
                      ให้ท่านแจ้งหรือกรอกข้อมูลส่วนบุคคลของท่าน เช่น
                      รหัสนักศึกษา รหัสอาจารย์ รหัสบุคคลากร รหัสผู้ใช้งานภายนอก
                      อีเมล อาชีพ ที่อยู่ เลขประจำตัวประชาชน
                      และหมายเลขโทรศัพท์เป็นต้น
                      สำหรับเว็บไซต์ที่ต้องให้มีการลงทะเบียนก่อนการใช้งาน
                      เพื่อจัดเก็บและบันทึกไว้ในบัญชีผู้ใช้งาน ภายในเว็บไซต์
                      นอกจากนี้
                      หากท่านประสงค์ที่จะใช้ประโยชน์อย่างเต็มที่จากการใช้งานเว็บไซต์
                      ผู้ให้บริการอาจต้องขอให้ท่านสร้างโปรไฟล์สาธารณะที่มีชื่อและรูปภาพของท่านอยู่ด้วย
                    </p>
                    <h6>
                      ข้อมูลที่ผู้ให้บริการได้รับจากการใช้งานเว็บไซต์ของท่านข้อมูลที่ท่านให้ผู้ให้บริการ
                    </h6>
                    <p class="indent">
                      ผู้ให้บริการรวบรวมข้อมูลจากการใช้งานเว็บไซต์ของท่าน เช่น
                      ค้นหาหนังสือ
                      หรือเมื่อท่านเรียกดูข่าวสารของผู้ให้บริการเป็นต้น
                      ซึ่งประกอบด้วยข้อมูลอย่างน้อยดังนี้<br />

                      (1) ข้อมูลเครื่องโทรศัพท์เคลื่อนที่/อุปกรณ์ดิจิตอล :
                      ผู้ให้บริการจะรวบรวมข้อมูลเฉพาะของอุปกรณ์ เช่น
                      รุ่นฮาร์ดแวร์ ระบบปฏิบัติการและรุ่นของระบบปฏิบัติการ
                      ข้อมูลเครือข่ายโทรศัพท์เคลื่อนที่ หมายเลขโทรศัพท์
                      ตลอดจนตัวระบุอุปกรณ์ที่ทำให้ผู้ให้บริการทราบว่าท่านเข้าใช้งานเว็บไซต์จากเครื่องใด
                      เพื่อนำมาปรับแต่งการให้บริการและวิเคราะห์ปัญหาที่เหมาะสมกับอุปกรณ์นั้นๆ<br />
                      (2) ข้อมูลที่ถูกบันทึก :
                      เมื่อท่านเรียกดูข้อมูลและ/หรือเนื้อหาจากเว็บไซต์นี้
                      ผู้ให้บริการจะบันทึกการเรียกดูข้อมูลและ/หรือเนื้อหาดังกล่าวไว้ในแหล่งรวบรวมในเซิร์ฟเวอร์ของผู้ให้บริการเอง<br />
                      (3) ข้อมูลสถานะของเครื่องโทรศัพท์เคลื่อนที่ (Phone State)
                      :
                      ผู้ให้บริการอาจเข้าถึงและประมวลผลข้อมูลเกี่ยวกับสถานะการทำงานของเครื่องโทรศัพท์เคลื่อนที่ของท่านว่าเปิดเครื่อง
                      หรือปิดเครื่องอยู่
                      และ/หรือข้อมูลเกี่ยวกับการเชื่อมต่อเครือข่าย<br />
                      เช่น เลือกเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                      หรือระบบ Wi-Fi เป็นต้น วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      -
                      เพื่อให้สามารถตรวจสอบได้ว่าท่านสามารถใช้งานเว็บไซต์ได้โดยทันที
                      โดยไม่จำเป็นต้องกรอกข้อมูล OTP ก่อนใช้งานหรือไม่
                    </p>
                    <p class="indent">
                      - เพื่อการจัดทำรูปแบบหน้าจอแสดงผลของเว็บไซต์
                    </p>
                    <p class="indent">
                      -
                      เพื่อปรับแต่งการให้บริการเว็บไซต์ที่เหมาะสมกับสถานะการใช้งานเครื่องแต่ละรูปแบบ
                      เช่น การสลับรูปแบบการใช้งานเป็นต้น
                    </p>
                    <p>
                      (4) ข้อมูลบัญชีผู้ใช้งานเว็บไซต์ (Account) :
                      เมื่อท่านใช้งานเว็บไซต์ของผู้ให้บริการ
                      ผู้ให้บริการอาจเข้าถึง
                      รวบรวมและประมวลผลข้อมูลเกี่ยวกับบัญชีผู้ใช้งานเว็บไซต์
                      (Account) ของท่าน สำหรับการตรวจสอบ Token และ/หรือ UDID
                      ของเครื่องโทรศัพท์เคลื่อนที่ วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      -
                      เพื่อการจัดทำข่าวประชาสัมพันธ์เกี่ยวกับผู้ให้บริการและเว็บไซต์
                    </p>
                    <p class="indent">- แสดงข้อมูลหนังสือแนะนำ</p>
                    <p>
                      (5) คุกกี้และเทคโนโลยีที่คล้ายกัน (Cookies and Similar
                      Technologies) : ผู้ให้บริการ อาจใช้เทคโนโลยีต่างๆ
                      ในการรวบรวมและจัดเก็บข้อมูลเมื่อท่านเยี่ยมชมเว็บไซต์และ/หรือบริการของผู้ให้บริการ
                      โดยการใช้คุกกี้และเทคโนโลยีที่คล้ายกัน
                      เพื่อระบุเบราว์เซอร์ หรืออุปกรณ์
                      และ/หรือเพื่อรวบรวมและจัดเก็บข้อมูลเมื่อท่านมีการโต้ตอบกับบริการที่ผู้ให้บริการ
                      เช่น บริการประชาสัมพันธ์ ข่าวสาร สื่อ เป็นต้น <br />
                      (6) ข้อมูลหมายเลขเฉพาะของเว็บไซต์ (Unique Application
                      Number) : เว็บไซต์นี้มีหมายเลขเฉพาะของเว็บไซต์
                      สำหรับการส่งข้อมูลมายังผู้ให้บริการ
                      เมื่อผู้ใช้บริการเข้าใช้งานเว็บไซต์นั้นๆ
                      หรือเมื่อเว็บไซต์นั้นติดต่อกับระบบเซิร์ฟเวอร์การให้บริการของผู้ให้บริการเป็นคราวๆไป
                      วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      - เพื่อการอัปเดตข้อมูลเว็บไซต์โดยอัตโนมัติ
                    </p>
                    <p>
                      (7) ข้อมูลพื้นที่การจัดเก็บข้อมูลในตัวเครื่อง (Storage) :
                      ผู้ให้บริการอาจรวบรวมและจัดเก็บข้อมูล
                      พื้นที่การจัดเก็บข้อมูลในตัวเครื่อง
                      รวมถึงข้อมูลส่วนบุคคลที่อยู่ในอุปกรณ์ของท่าน
                      โดยใช้วิธีการต่างๆ เช่น
                      พื้นที่จัดเก็บข้อมูลเว็บเบราว์เซอร์
                      และแคชของข้อมูลเว็บไซต์ วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      - เพื่ออนุญาตให้เว็บไซต์สามารถอ่านข้อมูลได้ -
                      เพื่อแสดงข้อมูลของผู้ใช้ตามการเข้าใช้งานบนเว็บไซต์
                    </p>
                    <h3>
                      ข้อตกลงและเงื่อนไขการใช้บริการ เว็บไซต์ UBRU Smart library
                    </h3>
                    <p class="indent">
                      เงื่อนไขการใช้บริการเว็บไซต์ UBRU Smart library
                      (ซึ่งต่อไปนี้จะเรียกว่า “เงื่อนไขการใช้บริการ”)
                      เป็นข้อตกลงสําหรับการใช้บริการเว็บไซต์ UBRU Smart library
                      ซึ่ง
                      เป็นการให้บริการเว็บไซต์ที่ช่วยให้ผู้ใช้บริการเข้าถึงบริการของสำนักวิทยบริการและเทคโนโลยีสารสนเทศได้อย่างสะดวก
                      และรวดเร็ว (UBRU Smart library) (ซึ่งต่อไปนี้จะเรียกว่า
                      “บริการ”) ซึ่งให้บริการโดย
                      สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                      (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ให้บริการ”) ฝ่ายหนึ่ง
                      กับผู้สมัครใช้บริการ เว็บไซต์ UBRU Smart library
                      (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ใช้บริการ”) อีกฝ่ายหนึ่ง
                      โดยเงื่อนไขการใช้บริการนี้อาจมีลักษณะกระทบสิทธิของผู้ใช้
                      บริการซึ่งผู้ใช้บริการควรอ่านและทําความเข้าใจอย่างละเอียดและหากมีข้อสงสัยเกี่ยวกับบริการของผู้ให้บริการ
                      ผู้ใช้บริการสามารถติดต่อสอบถาม ได้โดยทันทีที่
                      thongsian.c@ubru.ac.th
                    </p>

                    <h5>1. ข้อกําหนดทั่วไป</h5>
                    <p class="indent">
                      1.1
                      ผู้ใช้บริการตกลงที่จะปฏิบัติและผูกพันตามเงื่อนไขการใช้บริการ
                      ซึ่งการใช้บริการของผู้ใช้บริการถือเป็นการยอมรับเงื่อนไขการใช้บริการ
                      นี้
                      โดยผู้ให้บริการอาจแก้ไขหรือเพิ่มเติมเงื่อนไขการใช้บริการได้ไม่ว่าในเวลาใด
                      โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                      และการที่ผู้ใช้บริการ
                      ใช้บริการต่อไปภายหลังจากที่มีการแก้ไขหรือเพิ่มเติมดังกล่าว
                      ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                    </p>
                    <p class="indent">
                      1.2
                      ผู้ใช้บริการยอมรับว่าผู้ให้บริการมีสิทธิดําเนินการแก้ไข
                      เพิ่มเติม หรือปรับปรุงบริการ
                      ซึ่งผู้ใช้บริการอาจจําเป็นต้องอัปเดตเว็บไซต์ หรือ
                      ติดตั้งเว็บไซต์ใหม่ โดยให้ถือว่าบริการที่ได้แก้ไข
                      เพิ่มเติม
                      หรือปรับปรุงอยู่ภายใต้เงื่อนไขการใช้บริการฉบับนี้ทั้งสิ้น
                      และการที่ผู้ใช้
                      บริการใช้บริการต่อไปภายหลังจากที่มีการอัปเดตเว็บไซต์
                      หรือติดตั้งเว็บไซต์ใหม่
                      ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                    </p>
                    <p class="indent">
                      1.3 ผู้ให้บริการสงวนสิทธิ์ในการปรับปรุง
                      หรือยกเลิกการบริการ หรือส่วนใดส่วนหนึ่งของบริการ
                      ไม่ว่าจะเป็นการชั่วคราว
                      หรือตลอดไปได้ตลอดเวลาโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    </p>

                    <h5>2. การใช้บริการ</h5>
                    <p class="indent">
                      2.1 ในการสมัครใช้บริการ
                      ผู้ใช้บริการสามารถสมัครผ่านเว็บไซต์ UBRU Smart Library
                      (USL) โดยผู้ใช้บริการจะต้องระบุรหัสนักศึกษา รหัสอาจารย์
                      รหัสบุคคลกร รหัสผู้ใช้บุคคลภายนอก อาชีพ
                      ที่อยู่ไปรษณีย์อิเล็กทรอนิกส์ (E-Mail)
                      รหัสบัตรประจำตัวประชาชน
                      ระบบจะทำการกำหนดรหัสผ่านให้อัตโนมัติเพื่อ
                      ใช้ในการทํารายการต่างๆอันเกี่ยวเนื่องกับการใช้บริการ
                      โดยผู้ใช้บริการไม่สามารถแก้ไขเปลี่ยนแปลงรหัสผ่านนี้เองได้
                      ตามข้อ กําหนดและเงื่อนไขของผู้ให้บริการ
                    </p>

                    <p class="indent">
                      2.2
                      ผู้ใช้บริการจะต้องเก็บรักษารหัสผ่านนี้ไว้เป็นความลับเฉพาะตัวของผู้ใช้บริการเท่านั้น
                      ผู้ใช้บริการยอมรับว่า หากมีการกระทําการใดๆโดย
                      ใช้รหัสผ่านของผู้ใช้บริการ
                      ให้ถือว่าเป็นการกระทําโดยผู้ใช้บริการเองทุกประการ
                      และผู้ให้บริการไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจาก
                      การใช้รหัสผ่านดังกล่าว
                    </p>

                    <p class="indent">
                      2.3 ในกรณีที่ผู้ใช้บริการใช้รหัสผ่านทํารายการใดๆ
                      อันเกี่ยวเนื่องกับการใช้บริการเสร็จสิ้นสมบูรณ์แล้ว
                      ผู้ใช้บริการยอมรับว่าไม่สามารถ ยกเลิก เพิกถอน เปลี่ยนแปลง
                      หรือแก้ไขรายการดังกล่าวได้
                      และผู้ใช้บริการต้องผูกพันตามรายการดังกล่าวทุกประการ
                    </p>

                    <p class="indent">
                      2.4 ผู้ใช้บริการรับทราบว่า
                      ในการใช้บริการหากมีการป้อนรหัสผ่านผิดติดต่อกันมากกว่าจํานวนครั้งที่ผู้ให้บริการกําหนด
                      ผู้ให้บริการจะระงับการใช้ บริการโดยอัตโนมัติทันที
                      ผู้ใช้บริการจะสามารถใช้บริการนี้ต่อไปได้ก็ต่อเมื่อแจ้งความจํานงให้ผู้ให้บริการดําเนินการตามวิธีอื่นใดที่ผู้ให้บริการกําหนด
                      เพื่อขอออกรหัสผ่านใหม่
                    </p>

                    <p class="indent">
                      2.5 ในกรณีที่ผู้ใช้บริการลืมรหัสผ่าน
                      หรือต้องการเปลี่ยนแปลงรหัสผ่านไม่ว่าด้วยเหตุใดๆ
                      ผู้ใช้บริการต้องดําเนินการแจ้งให้ผู้ให้บริการทราบทันที
                      ตามวิธีการอื่นใดที่ผู้ให้บริการกําหนด อย่างไรก็ตาม
                      การดําเนินการต่างๆข้างต้นจะไม่มีผลกระทบต่อการดำเนินการกิจกรรมใดๆที่ได้ดําเนินการไปแล้วก่อนการแจ้งให้ผู้ให้บริการทราบ
                    </p>
                    <p class="indent">
                      2.6 ในการใช้บริการ
                      หากผู้ใช้บริการนําบริการของผู้ให้บริการไปประยุกต์ใช้งานใดๆ
                      ผู้ใช้บริการรับทราบว่าผู้ให้บริการจะไม่รับผิดชอบต่อความเสีย
                      หายใดๆที่เกิดขึ้นจากการดําเนินการดังกล่าวของผู้ใช้บริการ
                    </p>
                    <p class="indent">
                      2.7
                      ผู้ให้บริการจะให้บริการอย่างดีที่สุดเพื่อให้ผู้ใช้บริการได้รับบริการที่พึงพอใจ
                      ดังนั้น หากการให้บริการใดๆของผู้ให้บริการเกิดความผิดพลาด
                      ล่าช้า ไม่ว่าเกิดขึ้นจากระบบคอมพิวเตอร์ ระบบอินเตอร์เน็ต
                      อุปกรณ์อิเล็กทรอนิกส์ต่างๆ
                      หรือระบบอื่นใดที่เกี่ยวข้องกับการให้บริการนี้ รวมทั้ง
                      ระบบเครือข่ายโทรศัพท์เคลื่อนที่ และไม่ว่าจะเกิดจากเหตุใดๆ
                      ผู้ใช้บริการตกลงไม่ยกเอาเหตุขัดข้องดังกล่าวมาเป็นข้อเรียกร้องค่าเสียหาย
                      ใดๆจากผู้ให้บริการ
                    </p>
                    <p class="indent">
                      2.9
                      ผู้ให้บริการจะไม่รับผิดชอบในทุกกรณีต่อความสูญหายหรือเสียหาย
                      ไม่ว่าจะโดยทางตรง
                      หรือโดยทางอ้อมอันเกิดขึ้นกับข้อมูลในโทรศัพท์ เคลื่อนที่,
                      โปรแกรมคอมพิวเตอร์, Tablet, อุปกรณ์
                    </p>
                    <h5>3. ข้อตกลงอื่นๆ</h5>
                    <p class="indent">
                      3.1
                      ในกรณีที่ข้อใดของเงื่อนไขการใช้บริการฉบับนี้ไม่มีผลใช้บังคับ
                      หรือไม่สามารถใช้บังคับได้ ให้ข้ออื่นที่เหลือยังคงมีผล
                      และสามารถใช้ บังคับได้ตามที่กําหนดไว้
                    </p>
                    <p class="indent">
                      3.2
                      หัวข้อในสัญญา/ใบคําขอให้บริการฉบับนี้มีไว้เพื่ออ้างถึงเท่านั้น
                      และไม่มีผลกระทบถึงความหมายหรือส่งผลต่อการตีความแต่อย่างใด
                    </p>
                    <p class="indent">
                      3.3
                      เงื่อนไขการใช้บริการฉบับนี้ให้อยู่ภายใต้บังคับแห่งกฎหมายไทย
                    </p>
                    <h5>4. การเปลี่ยนแปลงข้อกำหนดและเงื่อนไขนี้</h5>
                    <p class="indent">
                      ผู้ให้บริการขอสงวนสิทธิ์ในการปรับปรุงข้อตกลงและเงื่อนไขการให้บริการเป็นครั้งคราวโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    </p>

                    <div padding>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เงื่อนไขการให้บริการนี้เป็นข้อตกลงระหว่าง
                      ซึ่งต่อไปนี้เรียกว่า "ผู้ให้บริการ" ฝ่ายหนึ่ง กับ
                      ผู้รับบริการ ซึ่งต่อไปนี้เรียกว่า "ผู้ใช้บริการ"
                      อีกฝ่ายหนึ่ง ซึ่งให้บริการ UBRU Smart Library Website
                      (USL) ซึ่งต่อไปนี้เรียกว่า "บริการ" โดยผู้ใช้บริการสามารถ
                      จอง (เพื่อยืม) หนังสือ จองห้องกลุ่มย่อย
                      ตรวจสอบวันส่งคืนหนังสือ ยืมหนังสือต่อ (Renew) ดูข่าวสาร
                      ดูประวัติยืมคืนหนังสือ
                      และประชาสัมพันธ์ต่างของสำนักวิทยบริการฯ
                    </div>

                    <template #modal-footer="{ ok }">
                      <b-button
                        size="lg"
                        @click="ok()"
                        class="btn btn-purple deep-purple btn-block"
                        pill
                      >
                        ฉันเข้าใจแล้ว
                      </b-button>
                    </template>
                  </b-modal>

                  <button
                    :disabled="!isCompleteRegister"
                    id="button"
                    type="submit"
                    class="btn btn-purple deep-purple btn-block"
                  >
                    ยืนยัน
                  </button>

                  <p>
                    <a
                      href="#"
                      @click="
                        (registerActive = !registerActive),
                          (emptyFields = false)
                      "
                      style="color: orangered; font-weight: bold"
                      >เข้าสู่ระบบ</a
                    >
                  </p>
                </form>
              </span> -->
              <!-- End -->
              <!-- teacher -->
              <!-- <span v-if="radio_btn === 'teacher'">
                <h6 style="color: red">{{ message_regis }}</h6>
                <form class="form-group" @submit.prevent="teacher_reg">
                  <input
                    v-model="inputTeacher.email"
                    type="email"
                    class="form-control input-style"
                    placeholder="อีเมล มหาวิทยาลัย"
                    required
                  />
                  <input
                    v-model="inputTeacher.phone"
                    type="phone"
                    class="form-control input-style"
                    placeholder="เบอร์โทรศัพท์"
                    required
                  />

                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="inputTeacher.chkpolicy"
                    type="checkbox"
                    class="text-left"
                    required
                  >
                    ข้าพเจ้าได้อ่านทำความเข้าใจและยอมรับ
                    <a
                      style="color: rgb(255, 95, 45); font-weight: bold"
                      v-b-modal.modal-1
                      >เงื่อนไข ข้อกำหนด ข้อตกลงการให้บริการ </a
                    >เป็นที่เรียบร้อยแล้ว
                  </b-form-checkbox>
                  <b-modal
                    id="modal-1"
                    size="lg"
                    class="border-bottom-0"
                    hide-header
                  >
                    <h5 class="my-4" style="font-weight: bold">
                      นโยบายความเป็นส่วนตัว
                    </h5>
                    <p class="indent">
                      นโยบายความเป็นส่วนตัวของสำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                      มหาวิทยาลัยราชภัฏอุบลราชธานี ซึ่งต่อไปนี้จะเรียกว่า
                      "ผู้ให้บริการ" สำหรับการใช้งานเว็บไซต์ UBRU Smart
                      library(USL) ด้านล่าง ซึ่งต่อไปนี้จะเรียกว่า “เว็บไซต์”<br />
                    </p>
                    <p class="indent">
                      โปรดอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัวนี้อย่างละเอียด
                      การที่ท่านได้เข้าใช้งานเว็บไซต์นี้แล้ว
                      ถือว่าท่านตกลงยอมรับข้อกำหนดที่ระบุในนโยบายความเป็นส่วนตัวนี้แล้วทุกประการ
                      หากท่านไม่สามารถยอมรับข้อกำหนดนโยบายความเป็นส่วนตัวนี้ได้
                      ขอให้ท่านปฏิเสธการใช้งานเว็บไซต์
                    </p>
                    <h5>1. วัตถุประสงค์ของนโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      ในการใช้งานเว็บไซต์นี้ผู้ให้บริการมีความประสงค์ที่จะแจ้งให้ท่านทราบอย่างชัดเจนว่าผู้ให้บริการรวบรวมข้อมูลส่วนใดของท่านบ้าง
                      มีวิธีการใช้และแบ่งปันข้อมูลของท่านอย่างไร
                      นโยบายความเป็นส่วนตัวนี้จะอธิบายถึง<br />
                    </p>
                    <p class="indent">
                      - ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม<br />
                    </p>
                    <p class="indent">- การใช้ข้อมูลที่รวบรวม<br /></p>
                    <p class="indent">
                      ผู้ให้บริการจะใช้ข้อมูลที่รวบรวมจากเว็บไซต์ทั้งหมดของผู้ให้บริการ
                      เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                      และพัฒนาบริการใหม่ๆ
                      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                      ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                      แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                      แสดงข่าวประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                      ผู้ให้บริการอาจใช้ข้อมูลที่รวบรวมได้จากคุกกี้ อีเมล
                      เบอร์โทรศัพท์และเทคโนโลยีอื่นๆ เช่น การใช้ Tag เป็นต้น
                      ในการปรับปรุงประสบการณ์การใช้งานของท่าน
                      และคุณภาพโดยรวมของเว็บไซต์
                    </p>
                    <h6>ข้อมูลที่แบ่งปัน</h6>
                    <p class="indent">
                      ผู้ให้บริการจะไม่นำข้อมูลของท่านไปแบ่งปันหรือเปิดเผยให้กับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก ยกเว้นกรณี
                      ดังต่อไปนี้
                    </p>
                    <p class="indent">
                      - เมื่อได้รับความยินยอมจากท่าน
                      ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                      เมื่อได้รับความยิมยอมจากท่านให้แบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนของท่านก่อน
                    </p>
                    <p class="indent">
                      - เพื่อ
                      “การใช้ข้อมูลที่รวบรวม”ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับคู่สัญญาที่มีหน้าที่บริหารจัดการเว็บไซต์ตามสัญญากับผู้ให้บริการโดยตรง
                      เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                      พัฒนาบริการใหม่ๆ และปกป้องผู้ให้บริการและท่าน
                      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                      ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                      แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                      แสดงโฆษณาประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                      โดยดำเนินการตามคำแนะนำและตามนโยบายส่วนบุคคลของผู้ให้บริการ
                      รวมถึงมาตรการการรักษาข้อมูลที่เป็นความลับและการรักษาความปลอดภัยที่เหมาะสม
                    </p>
                    <p class="indent">
                      - สำหรับเหตุผลทางกฎหมาย
                      ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลของท่านกับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                      หากผู้ให้บริการเชื่อโดยสุจริตว่าการเข้าถึง การใช้
                      การเก็บรักษา หรือการเปิดเผยข้อมูลนั้น มีเหตุจำเป็นอันสมควร
                      (1) เพื่อการปฏิบัติตามกฎหมาย ระเบียบข้อบังคับ หลักเกณฑ์
                      คำสั่งที่เกี่ยวข้องและการร้องขอข้อมูลจากทางราชการ (2)
                      เพื่อบังคับใช้ข้อกำหนดในการให้บริการที่เกี่ยวข้อง
                      รวมถึงการตรวจสอบการละเมิดที่อาจเกิดขึ้น (3) เพื่อตรวจจับ
                      ป้องกัน หรือตรวจสอบการทุจริต
                      ปัญหาด้านความปลอดภัยหรือด้านเทคนิค (4)
                      เพื่อป้องกันอันตรายต่อสิทธิ ทรัพย์สิน
                      หรือความปลอดภัยของผู้ให้บริการและ/หรือของท่าน
                      หรือบุคคลอื่นตามที่กฎหมายกำหนด
                      ผู้ให้บริการอาจแบ่งปันข้อมูลที่ไม่สามารถระบุตัวผู้ใช้งานเว็บไซต์
                      เช่น ผลการค้นหา เครือข่ายโทรศัพท์เคลื่อนที่ที่ใช้งาน
                      IPการเข้าใช้งาน เป็นต้น ต่อสาธารณะ เช่น
                      เว็บไซต์ที่เชื่อมโยงกัน เช่น
                      ผู้ให้บริการอาจแบ่งปันข้อมูลที่แสดงแนวโน้มการใช้งานเว็บไซต์
                      สู่สาธารณะ เป็นต้น
                    </p>
                    <h5>2. ความปลอดภัยของข้อมูล</h5>
                    <p class="indent">
                      ผู้ให้บริการพยายามอย่างยิ่งที่จะปกป้องข้อมูลของท่านจากการเข้าถึง
                      การแก้ไขเปลี่ยนแปลง การเปิดเผย
                      หรือการทำลายโดยไม่ได้รับอนุญาต อย่างน้อยดังนี้
                    </p>
                    <p class="indent">
                      - ผู้ให้บริการจัดทำระบบ One-Time Password (OTP)
                      เพื่อใช้ยืนยันผู้ใช้งานเว็บไซต์
                      เมื่อเข้าใช้งานโดยเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                      และ Wi-Fi
                    </p>
                    <p class="indent">
                      - ผู้ให้บริการตรวจสอบการเก็บรวบรวมข้อมูล
                      พื้นที่ในการจัดเก็บข้อมูลและหลักปฏิบัติในการประมวลผล
                      รวมถึงมาตรการความปลอดภัยทางกายภาพ
                      เพื่อป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
                    </p>
                    <p class="indent">
                      -
                      ผู้ให้บริการจำกัดการเข้าถึงข้อมูลส่วนบุคคลไว้เฉพาะกับพนักงาน
                      และลูกจ้าง ที่มีความจำเป็นต้องเข้าถึงข้อมูลนั้นๆ (Need to
                      Know Basis) เพื่อทำการประมวลผลข้อมูล
                      โดยที่บุคคลดังกล่าวนั้น
                      จะต้องปฏิบัติตามข้อกำหนดเกี่ยวกับการรักษาข้อมูลที่เป็นความลับตามสัญญาอย่างเคร่งครัด
                      หากฝ่าฝืนจะมีบทลงโทษขั้นรุนแรง
                    </p>

                    <h5>3. ข้อจำกัดการใช้นโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      นโยบายความเป็นส่วนตัวฉบับนี้
                      มีผลใช้บังคับกับเว็บไซต์นี้เท่านั้น
                      ไม่รวมถึงเว็บไซต์และ/หรือบริการที่มีนโยบายความเป็นส่วนตัว
                      แยกต่างหาก
                      และ/หรือที่ไม่ได้กำหนดโดยชัดแจ้งให้ใช้ร่วมกันกับนโยบายความเป็นส่วนตัวนี้
                      ตลอดจนไม่มีผลใช้บังคับกับเว็บไซต์และบริการ
                      หรือเว็บไซต์อื่นๆ ที่เชื่อมต่อ (link) กับเว็บไซต์นี้
                      รวมถึงไม่ครอบคลุมหลักปฏิบัติด้านข้อมูลส่วนบุคคลของบริษัทอื่นๆ
                      หรือองค์กรอื่นๆ ที่โฆษณาเว็บไซต์ของผู้ให้บริการ
                      ซึ่งอาจใช้คุกกี้ พิกเซลแท็ก และเทคโนโลยีอื่นๆ
                      ในการนำเสนอและแสดงโฆษณาที่เกี่ยวข้อง
                    </p>
                    <h5>
                      4.
                      การปฏิบัติตามกฎหมายและการให้ความร่วมมือกับหน่วยงานกำกับดูแล
                    </h5>
                    <p class="indent">
                      ผู้ให้บริการดำเนินการตรวจสอบและทบทวนการปฏิบัติตามนโยบายความเป็นส่วนตัว
                      และการปฏิบัติตามกฎหมายที่เกี่ยวข้อง
                      ภายในองค์กรอย่างสม่ำเสมอ (Self-Regulator)
                      หากผู้ให้บริการได้รับหนังสือร้องเรียนเกี่ยวกับการใช้ข้อมูลส่วนบุคคล
                      ผู้ให้บริการจะดำเนินการติดตามผล
                      ตลอดจนให้ความร่วมมือกับหน่วยงานของรัฐที่มีอำนาจกำกับดูแลการให้บริการเว็บไซต์
                      และหน่วยงานคุ้มครองผู้บริโภคต่างๆ
                    </p>
                    <h5>5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      ผู้ให้บริการขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลา
                      โดยไม่ต้องได้รับความยินยอมจากท่านล่วงหน้า
                      เว้นแต่เป็นการแก้ไขเปลี่ยนแปลงที่เป็นการริดรอนสิทธิของท่านตามนโยบายความเป็นส่วนตัวนี้
                      ผู้ให้บริการจะกระทำมิได้หากไม่ได้รับความยินยอมจากท่านก่อน
                    </p>
                    <h5>6. การเข้าถึงและอัปเดตข้อมูลส่วนบุคคล</h5>
                    <p class="indent">
                      ผู้ให้บริการมุ่งหวังเป็นอย่างยิ่งว่า ในการใช้เว็บไซต์
                      ท่านสามารถเข้าถึงข้อมูลส่วนบุคคลของท่านได้
                      หากข้อมูลดังกล่าวมีความบกพร่องหรือไม่ถูกต้อง
                      ผู้ให้บริการจะพยายามจัดหาวิธีการ
                      และ/หรือช่องทางให้ท่านสามารถอัปเดตและ/หรือลบข้อมูลส่วนบุคคลของท่าน
                      ได้อย่างเหมาะสม เว้นแต่
                      ในกรณีมีความจำเป็นที่ผู้ให้บริการจะต้องจัดเก็บข้อมูลส่วนบุคคลของท่านไว้
                      เพื่อประโยชน์ทางการให้บริการ
                      และ/หรือเพื่อการปฏิบัติตามกฎหมายที่ใช้บังคับ
                      เมื่อท่านดำเนินการอัปเดตข้อมูลส่วนบุคคลของท่าน
                      ผู้ให้บริการอาจร้องขอให้ท่านยืนยันตัวตนก่อนที่ผู้ให้บริการจะดำเนินการตามคำขอของท่านได้
                      ทั้งนี้
                      ผู้ให้บริการขอสงวนสิทธิ์ปฏิเสธการทำคำขออัปเดตและการเข้าถึงข้อมูลส่วนบุคคลของท่าน
                      ในกรณีดังต่อไปนี้ (1)
                      การทำคำขอที่ซับซ้อนและมีจำนวนมากเกินกว่าปกติ (2)
                      การดำเนินการตามคำขออาจทำให้ผู้ให้บริการต้องจัดหา
                      และ/หรือพัฒนาเทคโนโลยีจากที่ผู้ให้บริการมีอยู่เกินสมควร
                      (3)
                      การดำเนินการตามคำขออาจกระทบข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์อื่นๆ
                      หรือ (4) การดำเนินการตามคำขอไม่สามารถปฏิบัติได้จริง เช่น
                      คำขอเกี่ยวกับการเรียกดูข้อมูลส่วนบุคคลที่อยู่ในระบบสำรองข้อมูล
                      ผู้ให้บริการมุ่งหวังที่จะดำเนินการให้บริการเว็บไซต์ของผู้ให้บริการเป็นไปอย่างปลอดภัย
                      และสามารถป้องกันการทำลายข้อมูลจากอุบัติเหตุหรือการมุ่งร้ายอื่นๆ
                      ด้วยเหตุนี้
                      ภายหลังจากที่ท่านลบข้อมูลออกจากเว็บไซต์ของผู้ให้บริการแล้ว
                      ผู้ให้บริการอาจยังไม่ดำเนินการลบสำเนาข้อมูลส่วนบุคคลที่มีอยู่ออกจากเซิร์ฟเวอร์ที่ใช้งานอยู่
                      หรือนำข้อมูลออกจากระบบสำรองของผู้ให้บริการในทันที
                    </p>
                    <h6>ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม</h6>
                    <p class="indent">
                      “UBRU Smart Library เว็บไซต์
                      สำหรับใช้ในการจอง(เพื่อยืม)หนังสือ จองห้องกลุ่มย่อย
                      ตรวจเช็คการยืมคืนหนังสือ ค่าปรับหนังสือ กำหนดส่งหนังสือ
                      ค้นหาหนังสือ (OPAC) ประกาศข่าวสาร และยืมหนังสือต่อ (Renew)
                      เพื่อให้ผู้ใช้บริการได้ทราบถึงข้อมูลในการใช้บริการของผู้ให้บริการ
                      เป็นต้น”
                    </p>
                    <p class="indent">
                      ผู้ให้บริการเก็บรวบรวมข้อมูล
                      เพื่อนำมาใช้ในการพัฒนาและปรับปรุงการให้บริการที่ดีขึ้นแก่ท่าน
                      โดยเริ่มตั้งแต่ข้อมูลพื้นฐาน อย่างเช่น
                      ช่วงเวลาการจองหนังสือ เป็นต้น ตลอดจนข้อมูลที่มีความซับซ้อน
                      เช่น ประเภทหนังสือที่มีการจองมากที่สุด เป็นต้น
                      ด้วยวิธีดังต่อไปนี้
                    </p>
                    <h6>ข้อมูลที่ท่านให้ผู้ให้บริการ</h6>
                    <p class="indent">
                      ให้ท่านแจ้งหรือกรอกข้อมูลส่วนบุคคลของท่าน เช่น
                      รหัสนักศึกษา รหัสอาจารย์ รหัสบุคคลากร รหัสผู้ใช้งานภายนอก
                      อีเมล อาชีพ ที่อยู่ เลขประจำตัวประชาชน
                      และหมายเลขโทรศัพท์เป็นต้น
                      สำหรับเว็บไซต์ที่ต้องให้มีการลงทะเบียนก่อนการใช้งาน
                      เพื่อจัดเก็บและบันทึกไว้ในบัญชีผู้ใช้งาน ภายในเว็บไซต์
                      นอกจากนี้
                      หากท่านประสงค์ที่จะใช้ประโยชน์อย่างเต็มที่จากการใช้งานเว็บไซต์
                      ผู้ให้บริการอาจต้องขอให้ท่านสร้างโปรไฟล์สาธารณะที่มีชื่อและรูปภาพของท่านอยู่ด้วย
                    </p>
                    <h6>
                      ข้อมูลที่ผู้ให้บริการได้รับจากการใช้งานเว็บไซต์ของท่านข้อมูลที่ท่านให้ผู้ให้บริการ
                    </h6>
                    <p class="indent">
                      ผู้ให้บริการรวบรวมข้อมูลจากการใช้งานเว็บไซต์ของท่าน เช่น
                      ค้นหาหนังสือ
                      หรือเมื่อท่านเรียกดูข่าวสารของผู้ให้บริการเป็นต้น
                      ซึ่งประกอบด้วยข้อมูลอย่างน้อยดังนี้<br />

                      (1) ข้อมูลเครื่องโทรศัพท์เคลื่อนที่/อุปกรณ์ดิจิตอล :
                      ผู้ให้บริการจะรวบรวมข้อมูลเฉพาะของอุปกรณ์ เช่น
                      รุ่นฮาร์ดแวร์ ระบบปฏิบัติการและรุ่นของระบบปฏิบัติการ
                      ข้อมูลเครือข่ายโทรศัพท์เคลื่อนที่ หมายเลขโทรศัพท์
                      ตลอดจนตัวระบุอุปกรณ์ที่ทำให้ผู้ให้บริการทราบว่าท่านเข้าใช้งานเว็บไซต์จากเครื่องใด
                      เพื่อนำมาปรับแต่งการให้บริการและวิเคราะห์ปัญหาที่เหมาะสมกับอุปกรณ์นั้นๆ<br />
                      (2) ข้อมูลที่ถูกบันทึก :
                      เมื่อท่านเรียกดูข้อมูลและ/หรือเนื้อหาจากเว็บไซต์นี้
                      ผู้ให้บริการจะบันทึกการเรียกดูข้อมูลและ/หรือเนื้อหาดังกล่าวไว้ในแหล่งรวบรวมในเซิร์ฟเวอร์ของผู้ให้บริการเอง<br />
                      (3) ข้อมูลสถานะของเครื่องโทรศัพท์เคลื่อนที่ (Phone State)
                      :
                      ผู้ให้บริการอาจเข้าถึงและประมวลผลข้อมูลเกี่ยวกับสถานะการทำงานของเครื่องโทรศัพท์เคลื่อนที่ของท่านว่าเปิดเครื่อง
                      หรือปิดเครื่องอยู่
                      และ/หรือข้อมูลเกี่ยวกับการเชื่อมต่อเครือข่าย<br />
                      เช่น เลือกเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                      หรือระบบ Wi-Fi เป็นต้น วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      -
                      เพื่อให้สามารถตรวจสอบได้ว่าท่านสามารถใช้งานเว็บไซต์ได้โดยทันที
                      โดยไม่จำเป็นต้องกรอกข้อมูล OTP ก่อนใช้งานหรือไม่
                    </p>
                    <p class="indent">
                      - เพื่อการจัดทำรูปแบบหน้าจอแสดงผลของเว็บไซต์
                    </p>
                    <p class="indent">
                      -
                      เพื่อปรับแต่งการให้บริการเว็บไซต์ที่เหมาะสมกับสถานะการใช้งานเครื่องแต่ละรูปแบบ
                      เช่น การสลับรูปแบบการใช้งานเป็นต้น
                    </p>
                    <p>
                      (4) ข้อมูลบัญชีผู้ใช้งานเว็บไซต์ (Account) :
                      เมื่อท่านใช้งานเว็บไซต์ของผู้ให้บริการ
                      ผู้ให้บริการอาจเข้าถึง
                      รวบรวมและประมวลผลข้อมูลเกี่ยวกับบัญชีผู้ใช้งานเว็บไซต์
                      (Account) ของท่าน สำหรับการตรวจสอบ Token และ/หรือ UDID
                      ของเครื่องโทรศัพท์เคลื่อนที่ วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      -
                      เพื่อการจัดทำข่าวประชาสัมพันธ์เกี่ยวกับผู้ให้บริการและเว็บไซต์
                    </p>
                    <p class="indent">- แสดงข้อมูลหนังสือแนะนำ</p>
                    <p>
                      (5) คุกกี้และเทคโนโลยีที่คล้ายกัน (Cookies and Similar
                      Technologies) : ผู้ให้บริการ อาจใช้เทคโนโลยีต่างๆ
                      ในการรวบรวมและจัดเก็บข้อมูลเมื่อท่านเยี่ยมชมเว็บไซต์และ/หรือบริการของผู้ให้บริการ
                      โดยการใช้คุกกี้และเทคโนโลยีที่คล้ายกัน
                      เพื่อระบุเบราว์เซอร์ หรืออุปกรณ์
                      และ/หรือเพื่อรวบรวมและจัดเก็บข้อมูลเมื่อท่านมีการโต้ตอบกับบริการที่ผู้ให้บริการ
                      เช่น บริการประชาสัมพันธ์ ข่าวสาร สื่อ เป็นต้น <br />
                      (6) ข้อมูลหมายเลขเฉพาะของเว็บไซต์ (Unique Application
                      Number) : เว็บไซต์นี้มีหมายเลขเฉพาะของเว็บไซต์
                      สำหรับการส่งข้อมูลมายังผู้ให้บริการ
                      เมื่อผู้ใช้บริการเข้าใช้งานเว็บไซต์นั้นๆ
                      หรือเมื่อเว็บไซต์นั้นติดต่อกับระบบเซิร์ฟเวอร์การให้บริการของผู้ให้บริการเป็นคราวๆไป
                      วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      - เพื่อการอัปเดตข้อมูลเว็บไซต์โดยอัตโนมัติ
                    </p>
                    <p>
                      (7) ข้อมูลพื้นที่การจัดเก็บข้อมูลในตัวเครื่อง (Storage) :
                      ผู้ให้บริการอาจรวบรวมและจัดเก็บข้อมูล
                      พื้นที่การจัดเก็บข้อมูลในตัวเครื่อง
                      รวมถึงข้อมูลส่วนบุคคลที่อยู่ในอุปกรณ์ของท่าน
                      โดยใช้วิธีการต่างๆ เช่น
                      พื้นที่จัดเก็บข้อมูลเว็บเบราว์เซอร์
                      และแคชของข้อมูลเว็บไซต์ วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      - เพื่ออนุญาตให้เว็บไซต์สามารถอ่านข้อมูลได้ -
                      เพื่อแสดงข้อมูลของผู้ใช้ตามการเข้าใช้งานบนเว็บไซต์
                    </p>
                    <h3>
                      ข้อตกลงและเงื่อนไขการใช้บริการ เว็บไซต์ UBRU Smart library
                    </h3>
                    <p class="indent">
                      เงื่อนไขการใช้บริการเว็บไซต์ UBRU Smart library
                      (ซึ่งต่อไปนี้จะเรียกว่า “เงื่อนไขการใช้บริการ”)
                      เป็นข้อตกลงสําหรับการใช้บริการเว็บไซต์ UBRU Smart library
                      ซึ่ง
                      เป็นการให้บริการเว็บไซต์ที่ช่วยให้ผู้ใช้บริการเข้าถึงบริการของสำนักวิทยบริการและเทคโนโลยีสารสนเทศได้อย่างสะดวก
                      และรวดเร็ว (UBRU Smart library) (ซึ่งต่อไปนี้จะเรียกว่า
                      “บริการ”) ซึ่งให้บริการโดย
                      สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                      (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ให้บริการ”) ฝ่ายหนึ่ง
                      กับผู้สมัครใช้บริการ เว็บไซต์ UBRU Smart library
                      (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ใช้บริการ”) อีกฝ่ายหนึ่ง
                      โดยเงื่อนไขการใช้บริการนี้อาจมีลักษณะกระทบสิทธิของผู้ใช้
                      บริการซึ่งผู้ใช้บริการควรอ่านและทําความเข้าใจอย่างละเอียดและหากมีข้อสงสัยเกี่ยวกับบริการของผู้ให้บริการ
                      ผู้ใช้บริการสามารถติดต่อสอบถาม ได้โดยทันทีที่
                      thongsian.c@ubru.ac.th
                    </p>

                    <h5>1. ข้อกําหนดทั่วไป</h5>
                    <p class="indent">
                      1.1
                      ผู้ใช้บริการตกลงที่จะปฏิบัติและผูกพันตามเงื่อนไขการใช้บริการ
                      ซึ่งการใช้บริการของผู้ใช้บริการถือเป็นการยอมรับเงื่อนไขการใช้บริการ
                      นี้
                      โดยผู้ให้บริการอาจแก้ไขหรือเพิ่มเติมเงื่อนไขการใช้บริการได้ไม่ว่าในเวลาใด
                      โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                      และการที่ผู้ใช้บริการ
                      ใช้บริการต่อไปภายหลังจากที่มีการแก้ไขหรือเพิ่มเติมดังกล่าว
                      ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                    </p>
                    <p class="indent">
                      1.2
                      ผู้ใช้บริการยอมรับว่าผู้ให้บริการมีสิทธิดําเนินการแก้ไข
                      เพิ่มเติม หรือปรับปรุงบริการ
                      ซึ่งผู้ใช้บริการอาจจําเป็นต้องอัปเดตเว็บไซต์ หรือ
                      ติดตั้งเว็บไซต์ใหม่ โดยให้ถือว่าบริการที่ได้แก้ไข
                      เพิ่มเติม
                      หรือปรับปรุงอยู่ภายใต้เงื่อนไขการใช้บริการฉบับนี้ทั้งสิ้น
                      และการที่ผู้ใช้
                      บริการใช้บริการต่อไปภายหลังจากที่มีการอัปเดตเว็บไซต์
                      หรือติดตั้งเว็บไซต์ใหม่
                      ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                    </p>
                    <p class="indent">
                      1.3 ผู้ให้บริการสงวนสิทธิ์ในการปรับปรุง
                      หรือยกเลิกการบริการ หรือส่วนใดส่วนหนึ่งของบริการ
                      ไม่ว่าจะเป็นการชั่วคราว
                      หรือตลอดไปได้ตลอดเวลาโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    </p>

                    <h5>2. การใช้บริการ</h5>
                    <p class="indent">
                      2.1 ในการสมัครใช้บริการ
                      ผู้ใช้บริการสามารถสมัครผ่านเว็บไซต์ UBRU Smart Library
                      (USL) โดยผู้ใช้บริการจะต้องระบุรหัสนักศึกษา รหัสอาจารย์
                      รหัสบุคคลกร รหัสผู้ใช้บุคคลภายนอก อาชีพ
                      ที่อยู่ไปรษณีย์อิเล็กทรอนิกส์ (E-Mail)
                      รหัสบัตรประจำตัวประชาชน
                      ระบบจะทำการกำหนดรหัสผ่านให้อัตโนมัติเพื่อ
                      ใช้ในการทํารายการต่างๆอันเกี่ยวเนื่องกับการใช้บริการ
                      โดยผู้ใช้บริการไม่สามารถแก้ไขเปลี่ยนแปลงรหัสผ่านนี้เองได้
                      ตามข้อ กําหนดและเงื่อนไขของผู้ให้บริการ
                    </p>

                    <p class="indent">
                      2.2
                      ผู้ใช้บริการจะต้องเก็บรักษารหัสผ่านนี้ไว้เป็นความลับเฉพาะตัวของผู้ใช้บริการเท่านั้น
                      ผู้ใช้บริการยอมรับว่า หากมีการกระทําการใดๆโดย
                      ใช้รหัสผ่านของผู้ใช้บริการ
                      ให้ถือว่าเป็นการกระทําโดยผู้ใช้บริการเองทุกประการ
                      และผู้ให้บริการไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจาก
                      การใช้รหัสผ่านดังกล่าว
                    </p>

                    <p class="indent">
                      2.3 ในกรณีที่ผู้ใช้บริการใช้รหัสผ่านทํารายการใดๆ
                      อันเกี่ยวเนื่องกับการใช้บริการเสร็จสิ้นสมบูรณ์แล้ว
                      ผู้ใช้บริการยอมรับว่าไม่สามารถ ยกเลิก เพิกถอน เปลี่ยนแปลง
                      หรือแก้ไขรายการดังกล่าวได้
                      และผู้ใช้บริการต้องผูกพันตามรายการดังกล่าวทุกประการ
                    </p>

                    <p class="indent">
                      2.4 ผู้ใช้บริการรับทราบว่า
                      ในการใช้บริการหากมีการป้อนรหัสผ่านผิดติดต่อกันมากกว่าจํานวนครั้งที่ผู้ให้บริการกําหนด
                      ผู้ให้บริการจะระงับการใช้ บริการโดยอัตโนมัติทันที
                      ผู้ใช้บริการจะสามารถใช้บริการนี้ต่อไปได้ก็ต่อเมื่อแจ้งความจํานงให้ผู้ให้บริการดําเนินการตามวิธีอื่นใดที่ผู้ให้บริการกําหนด
                      เพื่อขอออกรหัสผ่านใหม่
                    </p>

                    <p class="indent">
                      2.5 ในกรณีที่ผู้ใช้บริการลืมรหัสผ่าน
                      หรือต้องการเปลี่ยนแปลงรหัสผ่านไม่ว่าด้วยเหตุใดๆ
                      ผู้ใช้บริการต้องดําเนินการแจ้งให้ผู้ให้บริการทราบทันที
                      ตามวิธีการอื่นใดที่ผู้ให้บริการกําหนด อย่างไรก็ตาม
                      การดําเนินการต่างๆข้างต้นจะไม่มีผลกระทบต่อการดำเนินการกิจกรรมใดๆที่ได้ดําเนินการไปแล้วก่อนการแจ้งให้ผู้ให้บริการทราบ
                    </p>
                    <p class="indent">
                      2.6 ในการใช้บริการ
                      หากผู้ใช้บริการนําบริการของผู้ให้บริการไปประยุกต์ใช้งานใดๆ
                      ผู้ใช้บริการรับทราบว่าผู้ให้บริการจะไม่รับผิดชอบต่อความเสีย
                      หายใดๆที่เกิดขึ้นจากการดําเนินการดังกล่าวของผู้ใช้บริการ
                    </p>
                    <p class="indent">
                      2.7
                      ผู้ให้บริการจะให้บริการอย่างดีที่สุดเพื่อให้ผู้ใช้บริการได้รับบริการที่พึงพอใจ
                      ดังนั้น หากการให้บริการใดๆของผู้ให้บริการเกิดความผิดพลาด
                      ล่าช้า ไม่ว่าเกิดขึ้นจากระบบคอมพิวเตอร์ ระบบอินเตอร์เน็ต
                      อุปกรณ์อิเล็กทรอนิกส์ต่างๆ
                      หรือระบบอื่นใดที่เกี่ยวข้องกับการให้บริการนี้ รวมทั้ง
                      ระบบเครือข่ายโทรศัพท์เคลื่อนที่ และไม่ว่าจะเกิดจากเหตุใดๆ
                      ผู้ใช้บริการตกลงไม่ยกเอาเหตุขัดข้องดังกล่าวมาเป็นข้อเรียกร้องค่าเสียหาย
                      ใดๆจากผู้ให้บริการ
                    </p>
                    <p class="indent">
                      2.9
                      ผู้ให้บริการจะไม่รับผิดชอบในทุกกรณีต่อความสูญหายหรือเสียหาย
                      ไม่ว่าจะโดยทางตรง
                      หรือโดยทางอ้อมอันเกิดขึ้นกับข้อมูลในโทรศัพท์ เคลื่อนที่,
                      โปรแกรมคอมพิวเตอร์, Tablet, อุปกรณ์
                    </p>
                    <h5>3. ข้อตกลงอื่นๆ</h5>
                    <p class="indent">
                      3.1
                      ในกรณีที่ข้อใดของเงื่อนไขการใช้บริการฉบับนี้ไม่มีผลใช้บังคับ
                      หรือไม่สามารถใช้บังคับได้ ให้ข้ออื่นที่เหลือยังคงมีผล
                      และสามารถใช้ บังคับได้ตามที่กําหนดไว้
                    </p>
                    <p class="indent">
                      3.2
                      หัวข้อในสัญญา/ใบคําขอให้บริการฉบับนี้มีไว้เพื่ออ้างถึงเท่านั้น
                      และไม่มีผลกระทบถึงความหมายหรือส่งผลต่อการตีความแต่อย่างใด
                    </p>
                    <p class="indent">
                      3.3
                      เงื่อนไขการใช้บริการฉบับนี้ให้อยู่ภายใต้บังคับแห่งกฎหมายไทย
                    </p>
                    <h5>4. การเปลี่ยนแปลงข้อกำหนดและเงื่อนไขนี้</h5>
                    <p class="indent">
                      ผู้ให้บริการขอสงวนสิทธิ์ในการปรับปรุงข้อตกลงและเงื่อนไขการให้บริการเป็นครั้งคราวโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    </p>

                    <div padding>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เงื่อนไขการให้บริการนี้เป็นข้อตกลงระหว่าง
                      ซึ่งต่อไปนี้เรียกว่า "ผู้ให้บริการ" ฝ่ายหนึ่ง กับ
                      ผู้รับบริการ ซึ่งต่อไปนี้เรียกว่า "ผู้ใช้บริการ"
                      อีกฝ่ายหนึ่ง ซึ่งให้บริการ UBRU Smart Library Website
                      (USL) ซึ่งต่อไปนี้เรียกว่า "บริการ" โดยผู้ใช้บริการสามารถ
                      จอง (เพื่อยืม) หนังสือ จองห้องกลุ่มย่อย
                      ตรวจสอบวันส่งคืนหนังสือ ยืมหนังสือต่อ (Renew) ดูข่าวสาร
                      ดูประวัติยืมคืนหนังสือ
                      และประชาสัมพันธ์ต่างของสำนักวิทยบริการฯ
                    </div>

                    <template #modal-footer="{ ok }">
                      <b-button
                        size="lg"
                        @click="ok()"
                        class="btn btn-purple deep-purple btn-block"
                        pill
                      >
                        ฉันเข้าใจแล้ว
                      </b-button>
                    </template>
                  </b-modal>

                  <button
                    :disabled="!isCompleteTeacher"
                    id="button"
                    type="submit"
                    class="btn btn-purple deep-purple btn-block"
                  >
                    ยืนยัน
                  </button>

                  <p>
                    <a
                      href="#"
                      @click="
                        (registerActive = !registerActive),
                          (emptyFields = false)
                      "
                      style="color: orangered; font-weight: bold"
                      >เข้าสู่ระบบ</a
                    >
                  </p>
                </form>
              </span> -->
              <!-- END -->
              <!-- <span v-if="radio_btn === 'another'">
                <h6 style="color: red">{{ message_regis }}</h6>
                <form class="form-group" @submit.prevent="anathor_regreg">
                  <input
                    v-model="inputRegAnother.another_code"
                    type="text"
                    class="form-control input-style"
                    placeholder="รหัสที่ได้จากสลิป"
                    required
                  />
                  <input
                    v-model="inputRegAnother.email"
                    type="email"
                    class="form-control input-style"
                    placeholder="อีเมล"
                    required
                  />
                  <input
                    v-model="inputRegAnother.phone"
                    type="phone"
                    class="form-control input-style"
                    placeholder="เบอร์โทรศัพท์"
                    required
                  />
                  <input
                    v-model="inputRegAnother.job"
                    type="phone"
                    class="form-control input-style"
                    placeholder="อาชีพ"
                    required
                  />

                  <b-form-textarea
                    id="textarea"
                    class="form-control textarea-style"
                    v-model="inputRegAnother.address"
                    placeholder="ที่อยู่ ที่สามารถติดต่อได้"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                  <br />
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="inputRegAnother.chkpolicy"
                    type="checkbox"
                    class="text-left"
                    required
                  >
                    ข้าพเจ้าได้อ่านทำความเข้าใจและยอมรับ
                    <a
                      style="color: rgb(255, 95, 45); font-weight: bold"
                      v-b-modal.modal-1
                      >เงื่อนไข ข้อกำหนด ข้อตกลงการให้บริการ </a
                    >เป็นที่เรียบร้อยแล้ว
                  </b-form-checkbox>
                  <b-modal
                    id="modal-1"
                    size="lg"
                    class="border-bottom-0"
                    hide-header
                  >
                    <h5 class="my-4" style="font-weight: bold">
                      นโยบายความเป็นส่วนตัว
                    </h5>
                    <p class="indent">
                      นโยบายความเป็นส่วนตัวของสำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                      มหาวิทยาลัยราชภัฏอุบลราชธานี ซึ่งต่อไปนี้จะเรียกว่า
                      "ผู้ให้บริการ" สำหรับการใช้งานเว็บไซต์ UBRU Smart
                      library(USL) ด้านล่าง ซึ่งต่อไปนี้จะเรียกว่า “เว็บไซต์”<br />
                    </p>
                    <p class="indent">
                      โปรดอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัวนี้อย่างละเอียด
                      การที่ท่านได้เข้าใช้งานเว็บไซต์นี้แล้ว
                      ถือว่าท่านตกลงยอมรับข้อกำหนดที่ระบุในนโยบายความเป็นส่วนตัวนี้แล้วทุกประการ
                      หากท่านไม่สามารถยอมรับข้อกำหนดนโยบายความเป็นส่วนตัวนี้ได้
                      ขอให้ท่านปฏิเสธการใช้งานเว็บไซต์
                    </p>
                    <h5>1. วัตถุประสงค์ของนโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      ในการใช้งานเว็บไซต์นี้ผู้ให้บริการมีความประสงค์ที่จะแจ้งให้ท่านทราบอย่างชัดเจนว่าผู้ให้บริการรวบรวมข้อมูลส่วนใดของท่านบ้าง
                      มีวิธีการใช้และแบ่งปันข้อมูลของท่านอย่างไร
                      นโยบายความเป็นส่วนตัวนี้จะอธิบายถึง<br />
                    </p>
                    <p class="indent">
                      - ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม<br />
                    </p>
                    <p class="indent">- การใช้ข้อมูลที่รวบรวม<br /></p>
                    <p class="indent">
                      ผู้ให้บริการจะใช้ข้อมูลที่รวบรวมจากเว็บไซต์ทั้งหมดของผู้ให้บริการ
                      เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                      และพัฒนาบริการใหม่ๆ
                      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                      ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                      แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                      แสดงข่าวประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                      ผู้ให้บริการอาจใช้ข้อมูลที่รวบรวมได้จากคุกกี้ อีเมล
                      เบอร์โทรศัพท์และเทคโนโลยีอื่นๆ เช่น การใช้ Tag เป็นต้น
                      ในการปรับปรุงประสบการณ์การใช้งานของท่าน
                      และคุณภาพโดยรวมของเว็บไซต์
                    </p>
                    <h6>ข้อมูลที่แบ่งปัน</h6>
                    <p class="indent">
                      ผู้ให้บริการจะไม่นำข้อมูลของท่านไปแบ่งปันหรือเปิดเผยให้กับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก ยกเว้นกรณี
                      ดังต่อไปนี้
                    </p>
                    <p class="indent">
                      - เมื่อได้รับความยินยอมจากท่าน
                      ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                      เมื่อได้รับความยิมยอมจากท่านให้แบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนของท่านก่อน
                    </p>
                    <p class="indent">
                      - เพื่อ
                      “การใช้ข้อมูลที่รวบรวม”ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับคู่สัญญาที่มีหน้าที่บริหารจัดการเว็บไซต์ตามสัญญากับผู้ให้บริการโดยตรง
                      เพื่อให้บริการ บำรุงรักษา ป้องกัน ปรับปรุง
                      พัฒนาบริการใหม่ๆ และปกป้องผู้ให้บริการและท่าน
                      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize)
                      ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น
                      แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
                      แสดงโฆษณาประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
                      โดยดำเนินการตามคำแนะนำและตามนโยบายส่วนบุคคลของผู้ให้บริการ
                      รวมถึงมาตรการการรักษาข้อมูลที่เป็นความลับและการรักษาความปลอดภัยที่เหมาะสม
                    </p>
                    <p class="indent">
                      - สำหรับเหตุผลทางกฎหมาย
                      ผู้ให้บริการอาจแบ่งปันหรือเปิดเผยข้อมูลของท่านกับบริษัท
                      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
                      หากผู้ให้บริการเชื่อโดยสุจริตว่าการเข้าถึง การใช้
                      การเก็บรักษา หรือการเปิดเผยข้อมูลนั้น มีเหตุจำเป็นอันสมควร
                      (1) เพื่อการปฏิบัติตามกฎหมาย ระเบียบข้อบังคับ หลักเกณฑ์
                      คำสั่งที่เกี่ยวข้องและการร้องขอข้อมูลจากทางราชการ (2)
                      เพื่อบังคับใช้ข้อกำหนดในการให้บริการที่เกี่ยวข้อง
                      รวมถึงการตรวจสอบการละเมิดที่อาจเกิดขึ้น (3) เพื่อตรวจจับ
                      ป้องกัน หรือตรวจสอบการทุจริต
                      ปัญหาด้านความปลอดภัยหรือด้านเทคนิค (4)
                      เพื่อป้องกันอันตรายต่อสิทธิ ทรัพย์สิน
                      หรือความปลอดภัยของผู้ให้บริการและ/หรือของท่าน
                      หรือบุคคลอื่นตามที่กฎหมายกำหนด
                      ผู้ให้บริการอาจแบ่งปันข้อมูลที่ไม่สามารถระบุตัวผู้ใช้งานเว็บไซต์
                      เช่น ผลการค้นหา เครือข่ายโทรศัพท์เคลื่อนที่ที่ใช้งาน
                      IPการเข้าใช้งาน เป็นต้น ต่อสาธารณะ เช่น
                      เว็บไซต์ที่เชื่อมโยงกัน เช่น
                      ผู้ให้บริการอาจแบ่งปันข้อมูลที่แสดงแนวโน้มการใช้งานเว็บไซต์
                      สู่สาธารณะ เป็นต้น
                    </p>
                    <h5>2. ความปลอดภัยของข้อมูล</h5>
                    <p class="indent">
                      ผู้ให้บริการพยายามอย่างยิ่งที่จะปกป้องข้อมูลของท่านจากการเข้าถึง
                      การแก้ไขเปลี่ยนแปลง การเปิดเผย
                      หรือการทำลายโดยไม่ได้รับอนุญาต อย่างน้อยดังนี้
                    </p>
                    <p class="indent">
                      - ผู้ให้บริการจัดทำระบบ One-Time Password (OTP)
                      เพื่อใช้ยืนยันผู้ใช้งานเว็บไซต์
                      เมื่อเข้าใช้งานโดยเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                      และ Wi-Fi
                    </p>
                    <p class="indent">
                      - ผู้ให้บริการตรวจสอบการเก็บรวบรวมข้อมูล
                      พื้นที่ในการจัดเก็บข้อมูลและหลักปฏิบัติในการประมวลผล
                      รวมถึงมาตรการความปลอดภัยทางกายภาพ
                      เพื่อป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
                    </p>
                    <p class="indent">
                      -
                      ผู้ให้บริการจำกัดการเข้าถึงข้อมูลส่วนบุคคลไว้เฉพาะกับพนักงาน
                      และลูกจ้าง ที่มีความจำเป็นต้องเข้าถึงข้อมูลนั้นๆ (Need to
                      Know Basis) เพื่อทำการประมวลผลข้อมูล
                      โดยที่บุคคลดังกล่าวนั้น
                      จะต้องปฏิบัติตามข้อกำหนดเกี่ยวกับการรักษาข้อมูลที่เป็นความลับตามสัญญาอย่างเคร่งครัด
                      หากฝ่าฝืนจะมีบทลงโทษขั้นรุนแรง
                    </p>

                    <h5>3. ข้อจำกัดการใช้นโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      นโยบายความเป็นส่วนตัวฉบับนี้
                      มีผลใช้บังคับกับเว็บไซต์นี้เท่านั้น
                      ไม่รวมถึงเว็บไซต์และ/หรือบริการที่มีนโยบายความเป็นส่วนตัว
                      แยกต่างหาก
                      และ/หรือที่ไม่ได้กำหนดโดยชัดแจ้งให้ใช้ร่วมกันกับนโยบายความเป็นส่วนตัวนี้
                      ตลอดจนไม่มีผลใช้บังคับกับเว็บไซต์และบริการ
                      หรือเว็บไซต์อื่นๆ ที่เชื่อมต่อ (link) กับเว็บไซต์นี้
                      รวมถึงไม่ครอบคลุมหลักปฏิบัติด้านข้อมูลส่วนบุคคลของบริษัทอื่นๆ
                      หรือองค์กรอื่นๆ ที่โฆษณาเว็บไซต์ของผู้ให้บริการ
                      ซึ่งอาจใช้คุกกี้ พิกเซลแท็ก และเทคโนโลยีอื่นๆ
                      ในการนำเสนอและแสดงโฆษณาที่เกี่ยวข้อง
                    </p>
                    <h5>
                      4.
                      การปฏิบัติตามกฎหมายและการให้ความร่วมมือกับหน่วยงานกำกับดูแล
                    </h5>
                    <p class="indent">
                      ผู้ให้บริการดำเนินการตรวจสอบและทบทวนการปฏิบัติตามนโยบายความเป็นส่วนตัว
                      และการปฏิบัติตามกฎหมายที่เกี่ยวข้อง
                      ภายในองค์กรอย่างสม่ำเสมอ (Self-Regulator)
                      หากผู้ให้บริการได้รับหนังสือร้องเรียนเกี่ยวกับการใช้ข้อมูลส่วนบุคคล
                      ผู้ให้บริการจะดำเนินการติดตามผล
                      ตลอดจนให้ความร่วมมือกับหน่วยงานของรัฐที่มีอำนาจกำกับดูแลการให้บริการเว็บไซต์
                      และหน่วยงานคุ้มครองผู้บริโภคต่างๆ
                    </p>
                    <h5>5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h5>
                    <p class="indent">
                      ผู้ให้บริการขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลา
                      โดยไม่ต้องได้รับความยินยอมจากท่านล่วงหน้า
                      เว้นแต่เป็นการแก้ไขเปลี่ยนแปลงที่เป็นการริดรอนสิทธิของท่านตามนโยบายความเป็นส่วนตัวนี้
                      ผู้ให้บริการจะกระทำมิได้หากไม่ได้รับความยินยอมจากท่านก่อน
                    </p>
                    <h5>6. การเข้าถึงและอัปเดตข้อมูลส่วนบุคคล</h5>
                    <p class="indent">
                      ผู้ให้บริการมุ่งหวังเป็นอย่างยิ่งว่า ในการใช้เว็บไซต์
                      ท่านสามารถเข้าถึงข้อมูลส่วนบุคคลของท่านได้
                      หากข้อมูลดังกล่าวมีความบกพร่องหรือไม่ถูกต้อง
                      ผู้ให้บริการจะพยายามจัดหาวิธีการ
                      และ/หรือช่องทางให้ท่านสามารถอัปเดตและ/หรือลบข้อมูลส่วนบุคคลของท่าน
                      ได้อย่างเหมาะสม เว้นแต่
                      ในกรณีมีความจำเป็นที่ผู้ให้บริการจะต้องจัดเก็บข้อมูลส่วนบุคคลของท่านไว้
                      เพื่อประโยชน์ทางการให้บริการ
                      และ/หรือเพื่อการปฏิบัติตามกฎหมายที่ใช้บังคับ
                      เมื่อท่านดำเนินการอัปเดตข้อมูลส่วนบุคคลของท่าน
                      ผู้ให้บริการอาจร้องขอให้ท่านยืนยันตัวตนก่อนที่ผู้ให้บริการจะดำเนินการตามคำขอของท่านได้
                      ทั้งนี้
                      ผู้ให้บริการขอสงวนสิทธิ์ปฏิเสธการทำคำขออัปเดตและการเข้าถึงข้อมูลส่วนบุคคลของท่าน
                      ในกรณีดังต่อไปนี้ (1)
                      การทำคำขอที่ซับซ้อนและมีจำนวนมากเกินกว่าปกติ (2)
                      การดำเนินการตามคำขออาจทำให้ผู้ให้บริการต้องจัดหา
                      และ/หรือพัฒนาเทคโนโลยีจากที่ผู้ให้บริการมีอยู่เกินสมควร
                      (3)
                      การดำเนินการตามคำขออาจกระทบข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์อื่นๆ
                      หรือ (4) การดำเนินการตามคำขอไม่สามารถปฏิบัติได้จริง เช่น
                      คำขอเกี่ยวกับการเรียกดูข้อมูลส่วนบุคคลที่อยู่ในระบบสำรองข้อมูล
                      ผู้ให้บริการมุ่งหวังที่จะดำเนินการให้บริการเว็บไซต์ของผู้ให้บริการเป็นไปอย่างปลอดภัย
                      และสามารถป้องกันการทำลายข้อมูลจากอุบัติเหตุหรือการมุ่งร้ายอื่นๆ
                      ด้วยเหตุนี้
                      ภายหลังจากที่ท่านลบข้อมูลออกจากเว็บไซต์ของผู้ให้บริการแล้ว
                      ผู้ให้บริการอาจยังไม่ดำเนินการลบสำเนาข้อมูลส่วนบุคคลที่มีอยู่ออกจากเซิร์ฟเวอร์ที่ใช้งานอยู่
                      หรือนำข้อมูลออกจากระบบสำรองของผู้ให้บริการในทันที
                    </p>
                    <h6>ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม</h6>
                    <p class="indent">
                      “UBRU Smart Library เว็บไซต์
                      สำหรับใช้ในการจอง(เพื่อยืม)หนังสือ จองห้องกลุ่มย่อย
                      ตรวจเช็คการยืมคืนหนังสือ ค่าปรับหนังสือ กำหนดส่งหนังสือ
                      ค้นหาหนังสือ (OPAC) ประกาศข่าวสาร และยืมหนังสือต่อ (Renew)
                      เพื่อให้ผู้ใช้บริการได้ทราบถึงข้อมูลในการใช้บริการของผู้ให้บริการ
                      เป็นต้น”
                    </p>
                    <p class="indent">
                      ผู้ให้บริการเก็บรวบรวมข้อมูล
                      เพื่อนำมาใช้ในการพัฒนาและปรับปรุงการให้บริการที่ดีขึ้นแก่ท่าน
                      โดยเริ่มตั้งแต่ข้อมูลพื้นฐาน อย่างเช่น
                      ช่วงเวลาการจองหนังสือ เป็นต้น ตลอดจนข้อมูลที่มีความซับซ้อน
                      เช่น ประเภทหนังสือที่มีการจองมากที่สุด เป็นต้น
                      ด้วยวิธีดังต่อไปนี้
                    </p>
                    <h6>ข้อมูลที่ท่านให้ผู้ให้บริการ</h6>
                    <p class="indent">
                      ให้ท่านแจ้งหรือกรอกข้อมูลส่วนบุคคลของท่าน เช่น
                      รหัสนักศึกษา รหัสอาจารย์ รหัสบุคคลากร รหัสผู้ใช้งานภายนอก
                      อีเมล อาชีพ ที่อยู่ เลขประจำตัวประชาชน
                      และหมายเลขโทรศัพท์เป็นต้น
                      สำหรับเว็บไซต์ที่ต้องให้มีการลงทะเบียนก่อนการใช้งาน
                      เพื่อจัดเก็บและบันทึกไว้ในบัญชีผู้ใช้งาน ภายในเว็บไซต์
                      นอกจากนี้
                      หากท่านประสงค์ที่จะใช้ประโยชน์อย่างเต็มที่จากการใช้งานเว็บไซต์
                      ผู้ให้บริการอาจต้องขอให้ท่านสร้างโปรไฟล์สาธารณะที่มีชื่อและรูปภาพของท่านอยู่ด้วย
                    </p>
                    <h6>
                      ข้อมูลที่ผู้ให้บริการได้รับจากการใช้งานเว็บไซต์ของท่านข้อมูลที่ท่านให้ผู้ให้บริการ
                    </h6>
                    <p class="indent">
                      ผู้ให้บริการรวบรวมข้อมูลจากการใช้งานเว็บไซต์ของท่าน เช่น
                      ค้นหาหนังสือ
                      หรือเมื่อท่านเรียกดูข่าวสารของผู้ให้บริการเป็นต้น
                      ซึ่งประกอบด้วยข้อมูลอย่างน้อยดังนี้<br />

                      (1) ข้อมูลเครื่องโทรศัพท์เคลื่อนที่/อุปกรณ์ดิจิตอล :
                      ผู้ให้บริการจะรวบรวมข้อมูลเฉพาะของอุปกรณ์ เช่น
                      รุ่นฮาร์ดแวร์ ระบบปฏิบัติการและรุ่นของระบบปฏิบัติการ
                      ข้อมูลเครือข่ายโทรศัพท์เคลื่อนที่ หมายเลขโทรศัพท์
                      ตลอดจนตัวระบุอุปกรณ์ที่ทำให้ผู้ให้บริการทราบว่าท่านเข้าใช้งานเว็บไซต์จากเครื่องใด
                      เพื่อนำมาปรับแต่งการให้บริการและวิเคราะห์ปัญหาที่เหมาะสมกับอุปกรณ์นั้นๆ<br />
                      (2) ข้อมูลที่ถูกบันทึก :
                      เมื่อท่านเรียกดูข้อมูลและ/หรือเนื้อหาจากเว็บไซต์นี้
                      ผู้ให้บริการจะบันทึกการเรียกดูข้อมูลและ/หรือเนื้อหาดังกล่าวไว้ในแหล่งรวบรวมในเซิร์ฟเวอร์ของผู้ให้บริการเอง<br />
                      (3) ข้อมูลสถานะของเครื่องโทรศัพท์เคลื่อนที่ (Phone State)
                      :
                      ผู้ให้บริการอาจเข้าถึงและประมวลผลข้อมูลเกี่ยวกับสถานะการทำงานของเครื่องโทรศัพท์เคลื่อนที่ของท่านว่าเปิดเครื่อง
                      หรือปิดเครื่องอยู่
                      และ/หรือข้อมูลเกี่ยวกับการเชื่อมต่อเครือข่าย<br />
                      เช่น เลือกเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่
                      หรือระบบ Wi-Fi เป็นต้น วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      -
                      เพื่อให้สามารถตรวจสอบได้ว่าท่านสามารถใช้งานเว็บไซต์ได้โดยทันที
                      โดยไม่จำเป็นต้องกรอกข้อมูล OTP ก่อนใช้งานหรือไม่
                    </p>
                    <p class="indent">
                      - เพื่อการจัดทำรูปแบบหน้าจอแสดงผลของเว็บไซต์
                    </p>
                    <p class="indent">
                      -
                      เพื่อปรับแต่งการให้บริการเว็บไซต์ที่เหมาะสมกับสถานะการใช้งานเครื่องแต่ละรูปแบบ
                      เช่น การสลับรูปแบบการใช้งานเป็นต้น
                    </p>
                    <p>
                      (4) ข้อมูลบัญชีผู้ใช้งานเว็บไซต์ (Account) :
                      เมื่อท่านใช้งานเว็บไซต์ของผู้ให้บริการ
                      ผู้ให้บริการอาจเข้าถึง
                      รวบรวมและประมวลผลข้อมูลเกี่ยวกับบัญชีผู้ใช้งานเว็บไซต์
                      (Account) ของท่าน สำหรับการตรวจสอบ Token และ/หรือ UDID
                      ของเครื่องโทรศัพท์เคลื่อนที่ วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      -
                      เพื่อการจัดทำข่าวประชาสัมพันธ์เกี่ยวกับผู้ให้บริการและเว็บไซต์
                    </p>
                    <p class="indent">- แสดงข้อมูลหนังสือแนะนำ</p>
                    <p>
                      (5) คุกกี้และเทคโนโลยีที่คล้ายกัน (Cookies and Similar
                      Technologies) : ผู้ให้บริการ อาจใช้เทคโนโลยีต่างๆ
                      ในการรวบรวมและจัดเก็บข้อมูลเมื่อท่านเยี่ยมชมเว็บไซต์และ/หรือบริการของผู้ให้บริการ
                      โดยการใช้คุกกี้และเทคโนโลยีที่คล้ายกัน
                      เพื่อระบุเบราว์เซอร์ หรืออุปกรณ์
                      และ/หรือเพื่อรวบรวมและจัดเก็บข้อมูลเมื่อท่านมีการโต้ตอบกับบริการที่ผู้ให้บริการ
                      เช่น บริการประชาสัมพันธ์ ข่าวสาร สื่อ เป็นต้น <br />
                      (6) ข้อมูลหมายเลขเฉพาะของเว็บไซต์ (Unique Application
                      Number) : เว็บไซต์นี้มีหมายเลขเฉพาะของเว็บไซต์
                      สำหรับการส่งข้อมูลมายังผู้ให้บริการ
                      เมื่อผู้ใช้บริการเข้าใช้งานเว็บไซต์นั้นๆ
                      หรือเมื่อเว็บไซต์นั้นติดต่อกับระบบเซิร์ฟเวอร์การให้บริการของผู้ให้บริการเป็นคราวๆไป
                      วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      - เพื่อการอัปเดตข้อมูลเว็บไซต์โดยอัตโนมัติ
                    </p>
                    <p>
                      (7) ข้อมูลพื้นที่การจัดเก็บข้อมูลในตัวเครื่อง (Storage) :
                      ผู้ให้บริการอาจรวบรวมและจัดเก็บข้อมูล
                      พื้นที่การจัดเก็บข้อมูลในตัวเครื่อง
                      รวมถึงข้อมูลส่วนบุคคลที่อยู่ในอุปกรณ์ของท่าน
                      โดยใช้วิธีการต่างๆ เช่น
                      พื้นที่จัดเก็บข้อมูลเว็บเบราว์เซอร์
                      และแคชของข้อมูลเว็บไซต์ วัตถุประสงค์ดังนี้
                    </p>
                    <p class="indent">
                      - เพื่ออนุญาตให้เว็บไซต์สามารถอ่านข้อมูลได้ -
                      เพื่อแสดงข้อมูลของผู้ใช้ตามการเข้าใช้งานบนเว็บไซต์
                    </p>
                    <h3>
                      ข้อตกลงและเงื่อนไขการใช้บริการ เว็บไซต์ UBRU Smart library
                    </h3>
                    <p class="indent">
                      เงื่อนไขการใช้บริการเว็บไซต์ UBRU Smart library
                      (ซึ่งต่อไปนี้จะเรียกว่า “เงื่อนไขการใช้บริการ”)
                      เป็นข้อตกลงสําหรับการใช้บริการเว็บไซต์ UBRU Smart library
                      ซึ่ง
                      เป็นการให้บริการเว็บไซต์ที่ช่วยให้ผู้ใช้บริการเข้าถึงบริการของสำนักวิทยบริการและเทคโนโลยีสารสนเทศได้อย่างสะดวก
                      และรวดเร็ว (UBRU Smart library) (ซึ่งต่อไปนี้จะเรียกว่า
                      “บริการ”) ซึ่งให้บริการโดย
                      สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
                      (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ให้บริการ”) ฝ่ายหนึ่ง
                      กับผู้สมัครใช้บริการ เว็บไซต์ UBRU Smart library
                      (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ใช้บริการ”) อีกฝ่ายหนึ่ง
                      โดยเงื่อนไขการใช้บริการนี้อาจมีลักษณะกระทบสิทธิของผู้ใช้
                      บริการซึ่งผู้ใช้บริการควรอ่านและทําความเข้าใจอย่างละเอียดและหากมีข้อสงสัยเกี่ยวกับบริการของผู้ให้บริการ
                      ผู้ใช้บริการสามารถติดต่อสอบถาม ได้โดยทันทีที่
                      thongsian.c@ubru.ac.th
                    </p>

                    <h5>1. ข้อกําหนดทั่วไป</h5>
                    <p class="indent">
                      1.1
                      ผู้ใช้บริการตกลงที่จะปฏิบัติและผูกพันตามเงื่อนไขการใช้บริการ
                      ซึ่งการใช้บริการของผู้ใช้บริการถือเป็นการยอมรับเงื่อนไขการใช้บริการ
                      นี้
                      โดยผู้ให้บริการอาจแก้ไขหรือเพิ่มเติมเงื่อนไขการใช้บริการได้ไม่ว่าในเวลาใด
                      โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                      และการที่ผู้ใช้บริการ
                      ใช้บริการต่อไปภายหลังจากที่มีการแก้ไขหรือเพิ่มเติมดังกล่าว
                      ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                    </p>
                    <p class="indent">
                      1.2
                      ผู้ใช้บริการยอมรับว่าผู้ให้บริการมีสิทธิดําเนินการแก้ไข
                      เพิ่มเติม หรือปรับปรุงบริการ
                      ซึ่งผู้ใช้บริการอาจจําเป็นต้องอัปเดตเว็บไซต์ หรือ
                      ติดตั้งเว็บไซต์ใหม่ โดยให้ถือว่าบริการที่ได้แก้ไข
                      เพิ่มเติม
                      หรือปรับปรุงอยู่ภายใต้เงื่อนไขการใช้บริการฉบับนี้ทั้งสิ้น
                      และการที่ผู้ใช้
                      บริการใช้บริการต่อไปภายหลังจากที่มีการอัปเดตเว็บไซต์
                      หรือติดตั้งเว็บไซต์ใหม่
                      ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง
                    </p>
                    <p class="indent">
                      1.3 ผู้ให้บริการสงวนสิทธิ์ในการปรับปรุง
                      หรือยกเลิกการบริการ หรือส่วนใดส่วนหนึ่งของบริการ
                      ไม่ว่าจะเป็นการชั่วคราว
                      หรือตลอดไปได้ตลอดเวลาโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    </p>

                    <h5>2. การใช้บริการ</h5>
                    <p class="indent">
                      2.1 ในการสมัครใช้บริการ
                      ผู้ใช้บริการสามารถสมัครผ่านเว็บไซต์ UBRU Smart Library
                      (USL) โดยผู้ใช้บริการจะต้องระบุรหัสนักศึกษา รหัสอาจารย์
                      รหัสบุคคลกร รหัสผู้ใช้บุคคลภายนอก อาชีพ
                      ที่อยู่ไปรษณีย์อิเล็กทรอนิกส์ (E-Mail)
                      รหัสบัตรประจำตัวประชาชน
                      ระบบจะทำการกำหนดรหัสผ่านให้อัตโนมัติเพื่อ
                      ใช้ในการทํารายการต่างๆอันเกี่ยวเนื่องกับการใช้บริการ
                      โดยผู้ใช้บริการไม่สามารถแก้ไขเปลี่ยนแปลงรหัสผ่านนี้เองได้
                      ตามข้อ กําหนดและเงื่อนไขของผู้ให้บริการ
                    </p>

                    <p class="indent">
                      2.2
                      ผู้ใช้บริการจะต้องเก็บรักษารหัสผ่านนี้ไว้เป็นความลับเฉพาะตัวของผู้ใช้บริการเท่านั้น
                      ผู้ใช้บริการยอมรับว่า หากมีการกระทําการใดๆโดย
                      ใช้รหัสผ่านของผู้ใช้บริการ
                      ให้ถือว่าเป็นการกระทําโดยผู้ใช้บริการเองทุกประการ
                      และผู้ให้บริการไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจาก
                      การใช้รหัสผ่านดังกล่าว
                    </p>

                    <p class="indent">
                      2.3 ในกรณีที่ผู้ใช้บริการใช้รหัสผ่านทํารายการใดๆ
                      อันเกี่ยวเนื่องกับการใช้บริการเสร็จสิ้นสมบูรณ์แล้ว
                      ผู้ใช้บริการยอมรับว่าไม่สามารถ ยกเลิก เพิกถอน เปลี่ยนแปลง
                      หรือแก้ไขรายการดังกล่าวได้
                      และผู้ใช้บริการต้องผูกพันตามรายการดังกล่าวทุกประการ
                    </p>

                    <p class="indent">
                      2.4 ผู้ใช้บริการรับทราบว่า
                      ในการใช้บริการหากมีการป้อนรหัสผ่านผิดติดต่อกันมากกว่าจํานวนครั้งที่ผู้ให้บริการกําหนด
                      ผู้ให้บริการจะระงับการใช้ บริการโดยอัตโนมัติทันที
                      ผู้ใช้บริการจะสามารถใช้บริการนี้ต่อไปได้ก็ต่อเมื่อแจ้งความจํานงให้ผู้ให้บริการดําเนินการตามวิธีอื่นใดที่ผู้ให้บริการกําหนด
                      เพื่อขอออกรหัสผ่านใหม่
                    </p>

                    <p class="indent">
                      2.5 ในกรณีที่ผู้ใช้บริการลืมรหัสผ่าน
                      หรือต้องการเปลี่ยนแปลงรหัสผ่านไม่ว่าด้วยเหตุใดๆ
                      ผู้ใช้บริการต้องดําเนินการแจ้งให้ผู้ให้บริการทราบทันที
                      ตามวิธีการอื่นใดที่ผู้ให้บริการกําหนด อย่างไรก็ตาม
                      การดําเนินการต่างๆข้างต้นจะไม่มีผลกระทบต่อการดำเนินการกิจกรรมใดๆที่ได้ดําเนินการไปแล้วก่อนการแจ้งให้ผู้ให้บริการทราบ
                    </p>
                    <p class="indent">
                      2.6 ในการใช้บริการ
                      หากผู้ใช้บริการนําบริการของผู้ให้บริการไปประยุกต์ใช้งานใดๆ
                      ผู้ใช้บริการรับทราบว่าผู้ให้บริการจะไม่รับผิดชอบต่อความเสีย
                      หายใดๆที่เกิดขึ้นจากการดําเนินการดังกล่าวของผู้ใช้บริการ
                    </p>
                    <p class="indent">
                      2.7
                      ผู้ให้บริการจะให้บริการอย่างดีที่สุดเพื่อให้ผู้ใช้บริการได้รับบริการที่พึงพอใจ
                      ดังนั้น หากการให้บริการใดๆของผู้ให้บริการเกิดความผิดพลาด
                      ล่าช้า ไม่ว่าเกิดขึ้นจากระบบคอมพิวเตอร์ ระบบอินเตอร์เน็ต
                      อุปกรณ์อิเล็กทรอนิกส์ต่างๆ
                      หรือระบบอื่นใดที่เกี่ยวข้องกับการให้บริการนี้ รวมทั้ง
                      ระบบเครือข่ายโทรศัพท์เคลื่อนที่ และไม่ว่าจะเกิดจากเหตุใดๆ
                      ผู้ใช้บริการตกลงไม่ยกเอาเหตุขัดข้องดังกล่าวมาเป็นข้อเรียกร้องค่าเสียหาย
                      ใดๆจากผู้ให้บริการ
                    </p>
                    <p class="indent">
                      2.9
                      ผู้ให้บริการจะไม่รับผิดชอบในทุกกรณีต่อความสูญหายหรือเสียหาย
                      ไม่ว่าจะโดยทางตรง
                      หรือโดยทางอ้อมอันเกิดขึ้นกับข้อมูลในโทรศัพท์ เคลื่อนที่,
                      โปรแกรมคอมพิวเตอร์, Tablet, อุปกรณ์
                    </p>
                    <h5>3. ข้อตกลงอื่นๆ</h5>
                    <p class="indent">
                      3.1
                      ในกรณีที่ข้อใดของเงื่อนไขการใช้บริการฉบับนี้ไม่มีผลใช้บังคับ
                      หรือไม่สามารถใช้บังคับได้ ให้ข้ออื่นที่เหลือยังคงมีผล
                      และสามารถใช้ บังคับได้ตามที่กําหนดไว้
                    </p>
                    <p class="indent">
                      3.2
                      หัวข้อในสัญญา/ใบคําขอให้บริการฉบับนี้มีไว้เพื่ออ้างถึงเท่านั้น
                      และไม่มีผลกระทบถึงความหมายหรือส่งผลต่อการตีความแต่อย่างใด
                    </p>
                    <p class="indent">
                      3.3
                      เงื่อนไขการใช้บริการฉบับนี้ให้อยู่ภายใต้บังคับแห่งกฎหมายไทย
                    </p>
                    <h5>4. การเปลี่ยนแปลงข้อกำหนดและเงื่อนไขนี้</h5>
                    <p class="indent">
                      ผู้ให้บริการขอสงวนสิทธิ์ในการปรับปรุงข้อตกลงและเงื่อนไขการให้บริการเป็นครั้งคราวโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                    </p>

                    <div padding>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เงื่อนไขการให้บริการนี้เป็นข้อตกลงระหว่าง
                      ซึ่งต่อไปนี้เรียกว่า "ผู้ให้บริการ" ฝ่ายหนึ่ง กับ
                      ผู้รับบริการ ซึ่งต่อไปนี้เรียกว่า "ผู้ใช้บริการ"
                      อีกฝ่ายหนึ่ง ซึ่งให้บริการ UBRU Smart Library Website
                      (USL) ซึ่งต่อไปนี้เรียกว่า "บริการ" โดยผู้ใช้บริการสามารถ
                      จอง (เพื่อยืม) หนังสือ จองห้องกลุ่มย่อย
                      ตรวจสอบวันส่งคืนหนังสือ ยืมหนังสือต่อ (Renew) ดูข่าวสาร
                      ดูประวัติยืมคืนหนังสือ
                      และประชาสัมพันธ์ต่างของสำนักวิทยบริการฯ
                    </div>

                    <template #modal-footer="{ ok }">
                      <b-button
                        size="lg"
                        @click="ok()"
                        class="btn btn-purple deep-purple btn-block"
                        pill
                      >
                        ฉันเข้าใจแล้ว
                      </b-button>
                    </template>
                  </b-modal>

                  <button
                    :disabled="!isCompleteRegAnathor"
                    id="button"
                    type="submit"
                    class="btn btn-purple deep-purple btn-block"
                  >
                    ยืนยัน
                  </button>

                  <p>
                    <a
                      href="#"
                      @click="
                        (registerActive = !registerActive),
                          (emptyFields = false)
                      "
                      style="color: orangered; font-weight: bold"
                      >เข้าสู่ระบบ</a
                    >
                  </p>
                </form>
              </span> -->
              <!--  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import $ from "jquery";
import router from "@/router";
export default {
  name: "Login",
  data() {
    return {
      registerActive: false,
      emptyFields: false,
      secret_one: "",
      keycomponent: "",
      datas: "",
      timespit: "",
      token: "",
      access_token: "",
      ipAddress: "",
      inputReg: {
        std_code: "",
        email: "",
        phone: "",
        chkpolicy: "",
      },
      inputRegAnother: {
        another_code: "",
        email: "",
        phone: "",
        address: "",
        job: "",
        chkpolicy: "",
      },
      inputTeacher: {
        email: "",
        phone: "",
        chkpolicy: "",
      },
      inputLogin: {
        std_code: "",
        password: "",
      },
      isLoading: false,
      message: "",
      message_regis: "",
      auth: [],
      radio_btn: "",
    };
  },
  mounted() {
    this.getIP();
  },
  computed: {
    isComplete() {
      return this.inputLogin.std_code && this.inputLogin.password;
    },
    isCompleteRegister() {
      return (
        this.inputReg.std_code &&
        this.inputReg.email &&
        this.inputReg.phone &&
        this.inputReg.chkpolicy
      );
    },
    isCompleteRegAnathor() {
      return (
        this.inputRegAnother.another_code &&
        this.inputRegAnother.phone &&
        this.inputRegAnother.email &&
        this.inputRegAnother.job &&
        this.inputRegAnother.address &&
        this.inputRegAnother.chkpolicy
      );
    },
    isCompleteTeacher() {
      return (
        this.inputTeacher.email &&
        this.inputTeacher.phone &&
        this.inputTeacher.chkpolicy
      );
    },
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    getIP() {
      this.getIPAddress().then((res) => {
        this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
      });
    },
    getIPAddress() {
      return axios.get("https://api.ipify.org/?format=json");
    },
    login() {
      let std_code = this.inputLogin.std_code;
      let password = this.inputLogin.password;
      this.$isLoading(true);
      this.$store
        .dispatch("login", { std_code, password })
        .then((res) => {
          console.log(res);
          if (localStorage.getItem("auth") != null) {
            this.auth = JSON.parse(localStorage.getItem("auth"));
          }

          if (res.msg.status != 200) {
            this.$isLoading(false);
            this.message = res.msg.message;
            // localStorage.setItem("login",false);
            // this.loginModal = JSON.parse(localStorage.getItem("login"))
            //     console.log(this.loginModal);
          } else {
            if (this.auth.isLibraryStaff === 1) {
              this.$isLoading(false);
              this.$router.push("/staff");
              console.log(this.auth);
              // localStorage.setItem("login",true)
              //  this.loginModal = JSON.parse(localStorage.getItem("login"))
              // console.log(this.loginModal);
              // this.staff = true
            } else {
              this.$isLoading(false);
              router.back();
              // this.$router.push("/");

              // localStorage.setItem("login",true)
              //  this.loginModal = JSON.parse(localStorage.getItem("login"))
              //   console.log(this.loginModal);
            }
          }
        })
        .catch((err) => console.log(err));
    },
    register() {
      let std_code = this.inputReg.std_code;
      let email = this.inputReg.email;
      let phone = this.inputReg.phone;
      this.$isLoading(true);
      this.$store
        .dispatch("register", { std_code, email, phone })
        .then((res) => {
          if (res.msg.status != 200) {
            this.$isLoading(false);
            this.message_regis = res.msg.message;
          } else {
            this.$isLoading(false);
            this.$router.push("/enterphone");
          }
        })

        .catch((err) => console.log(err));
    },
    teacher_reg() {
      let email = this.inputTeacher.email;
      let phone = this.inputTeacher.phone;
      this.$store.dispatch("teacher", { email, phone }).then((res) => {
        console.log(res);
      });
    },
    anathor_reg() {},
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 19rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
  left: 0rem;
  top: 0rem;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6.8rem;
  height: 3.6rem;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 6.4rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6.1rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(12.1rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/

#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #f6f8fc;
  border-color: #f6f8fc;
  color: #000000;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  font-size: 0.9rem;
}
.textarea-style {
  border-radius: 10px;
  background-color: #f6f8fc;
  border-color: #f6f8fc;
  color: #000000;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  font-size: 0.9rem;
}
#login-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
  font-family: "Kanit", sans-serif;
}
#regis-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}

p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}
.form-group {
  font-family: "Kanit", sans-serif;
}
.form-group input {
  margin-bottom: 20px;
  font-family: "Kanit", sans-serif;
}
.form-group button {
  margin-bottom: 20px;
  font-family: "Kanit", sans-serif;
}
.form-group a {
  font-family: "Kanit", sans-serif;
  font-weight: bold;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  /* background: -webkit-linear-gradient(-55deg, #a05fc5 40%, #634bbb 100%)
    no-repeat center center; */
  /*  background: -webkit-linear-gradient(-55deg, #c55fb8 40%, #ae4bbb 100%)
    no-repeat center center;*/
  /*background: -webkit-linear-gradient(-55deg, #fc4a1a 40%, #f7b733 100%)
    no-repeat center center; */
  background-image: url(../../assets/img/bg-ubrulibray.jpeg);
  filter: blur(8px);
  -webkit-filter: blur(8px);
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.login-page .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/*.container{
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0, 0.4); 
  
  font-weight: bold;
  border: 0px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100%;
  height: auto;
  text-align: center;
}*/
.wallpaper-register {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */

  /* #a077ff 40%, #40cbea 100% */
  /* background: -webkit-linear-gradient(-55deg, #9b4bbb 40%, #c55fbd 100%)
    no-repeat center center; */
  /*   background: -webkit-linear-gradient(-55deg,#fe8c00 40%, #f83600 100%)
    no-repeat center center; 
  background: -webkit-linear-gradient(-55deg, #9b4bbb 40%, #c55fbd 100%)
    no-repeat center center;*/
  background-image: url(../../assets/img/bd-std.jpg);
  filter: blur(5px);
  -webkit-filter: blur(5px);

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  z-index: -1;
  font-family: "Kanit", sans-serif;
}

h1 {
  margin-bottom: 1.5rem;
  font-family: "Kanit", sans-serif;
  font-weight: bold;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}

.alert {
  background: #ffdb9b;
  padding: 20px 40px;
  min-width: 420px;
  position: absolute;
  right: 0;
  top: 10px;
  border-radius: 4px;
  border-left: 8px solid #ffa502;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.alert.showAlert {
  opacity: 1;
  pointer-events: auto;
}
.alert.show {
  animation: show_slide 1s ease forwards;
}
@keyframes show_slide {
  0% {
    transform: translateX(100%);
  }
  40% {
    transform: translateX(-10%);
  }
  80% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-10px);
  }
}
.alert.hide {
  animation: hide_slide 1s ease forwards;
}
@keyframes hide_slide {
  0% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(0%);
  }
  80% {
    transform: translateX(-10%);
  }
  100% {
    transform: translateX(100%);
  }
}

.alert .fa-exclamation-circle {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #ce8500;
  font-size: 30px;
}
.alert .msg {
  padding: 0 20px;
  font-size: 18px;
  color: #ce8500;
}
.alert .close-btn {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  background: #ffd080;
  padding: 20px 18px;
  cursor: pointer;
}
.alert .close-btn:hover {
  background: #ffc766;
}
.alert .close-btn .fas {
  color: #ce8500;
  font-size: 22px;
  line-height: 40px;
}

.btn-purple {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}

.btn-purple:hover {
  color: #fff;
  border-color: rgb(250, 129, 92);
  background-color: rgb(254, 110, 66);
}
.btn-purple:focus,
.btn-purple.focus {
  color: #fff;
  border-color: rgb(250, 129, 92);
  background-color: rgb(254, 110, 66);
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-purple.disabled,
.btn-purple:disabled {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}
.btn-purple:not(:disabled):not(.disabled):active,
.btn-purple:not(:disabled):not(.disabled).active,
.show > .btn-purple.dropdown-toggle {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(250, 129, 92);
}
.btn-purple:not(:disabled):not(.disabled):active:focus,
.btn-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
/*  */

.btn-outline-purple {
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:hover {
  color: #fff;
  background-color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:focus,
.btn-outline-purple.focus {
  box-shadow: 0 0 0 0.2rem rgb(250, 129, 92);
}

.btn-outline-purple.disabled,
.btn-outline-purple:disabled {
  color: rgb(255, 95, 45);
  background-color: transparent;
}

.btn-outline-purple:not(:disabled):not(.disabled):active,
.btn-outline-purple:not(:disabled):not(.disabled).active,
.show > .btn-outline-purple.dropdown-toggle {
  color: #fff;
  background-color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:not(:disabled):not(.disabled):active:focus,
.btn-outline-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgb(250, 129, 92);
}
</style>
